/* ----------------------- AVOID PUTTING CODE IN GLOBAL SCOPE  ----------------------------------- */
$(function () {
    /* ---- BEGIN LOCAL NAMED FUNCTIONS DECLARATION ----*/    
    // Localized variables kept in localizeddetails file
    var selBaseTrim = $('#selectedColorID');
    var catAlias = $('#CatalogAlias').val();
    var isApparelItem = $('.isApparelItem').val() == "True";
    var currencySymbol = $('#tdCurrencySymbol').val();
    var quantityTextbox = $('#txtQty').val();
    var nibInkInput = $('#nibInkSelection');
    var adhesiveInput = $('#adhesiveSelection');
    var recolorAvailable = $("#isRecolorable").val();
    var localizedJS = new localizedDetails();
    var steppingQty = parseInt($('#litSteppingQty').val());
    var totalLabel = $('#lblTotal').text();
    var priceLabel = $('#lblPrice').html();
    var quantityTextbox = $('#txtQty').val();
    var reportSKU = $('#ReportSKU').val();
    var ukShippingCost = $('#UKShippingCost').val();
    var ukTaxRate = $('#UKTaxRate').val();
    var baseExtra = $('#BaseExtra').val();
    var antiForgeryToken = { "__RequestVerificationToken": $('input[name=__RequestVerificationToken]').val() };
    var txtTimer = null;
    var isMobile = $('.contactPanel').css('display') == 'none';
    var isDesktop = $('.prodNumber').css('float') == 'none';
    var isTabMobile = $('.prodNumber').css('float') == 'left';
    var isTabletDesktop = $(".contactPanel").css("display") == 'block'; 
    var lastFocus;
    var prodScrollerJS = new prodScroller();
    if($(".tooltipWrapper").length){
    	var tooltips = new toolTips();
    	tooltips.init();
    }
    
    var isSuspended = document.getElementById("isSuspended") ? document.getElementById("isSuspended").value == 'True' : false;
    var loadExtraZoom = function () {
            $('a.extraProdImg').each(function(){
             		$(this).zoom({url: $(this).attr('href') });
             });
    };
    var cleanExtraZoom = function () {
        	$('a.extraProdImg').each(function(){
        		$(this).trigger('zoom.destroy');
        	});
    };
    var loadMainZoom = function () { $('a#hypProdImg').zoom({url: $('a#hypProdImg').attr("href")}); };
    var cleanMainZoom = function () { $("a#hypProdImg").trigger('zoom.destroy'); };

	function OmniLogCartAdd(newCart) {
	    if (typeof s != "undefined") {
	        s.events = (newCart) ? 'scOpen, scAdd' : 'scAdd';
	        /************* DO NOT ALTER ANYTHING BELOW THIS LINE ! **************/
	        var s_code = s.t(); if (s_code) document.write(s_code);
	    }
	} 
	
   $('.prodImages').removeClass('invisible');
   prodScrollerJS.InitScrollerMain();
	
    function MobileTweaks(){
        if(isMobile){
            $('section.prodImages').insertBefore('section.prodInfo');
            $(".SocialMediaButtons").insertBefore("section.prodDetails");
            $("#relatedProductsContainer").insertAfter("section#tabProd");
            $(".PD_Step_1").removeClass("borderDkGray");
            $(".PD_Step_2").removeClass("borderDkGray hide");
            $("#addToCartWrapper").parent().removeClass("padding20")
                                    .addClass("paddingTop20");
                                    
            $('.glidePanel').addClass('marginTop10').removeClass('marginTop40');
                    
            var slider = $("#photoSwipeBox").slick('getSlick');
      
            $('.zoomin').off('click keypress');
            $('.zoomin').on('click keypress', function(e) {
                if (e.type =='keypress' && !(e.which == 13)) { return;}
                //var activeSlide = slider.currentSlide;
                //var zoomUrl = $('#img'+ activeSlide).find("a").find("img").attr("src").replace("/300/", "/700/");
                //var imgAlt = $('#img'+ activeSlide).find("a").find("img").attr("alt");
                //$('#photoSwipeBoxWrapper').hide();
                //$('#photoZoomBox img').attr({
                //    src: zoomUrl,
                //    alt: imgAlt	
                //});
                //$('#photoZoomBoxParent').show(); 
                e.preventDefault();
                $(".zoomout").removeClass("hide");
                $(".zoomin").removeClass("showOnSmall").addClass("hide");
                $(".zoomDescription").removeClass("hide");
                loadExtraZoom();
                loadMainZoom();
                /*   
                $('#photoZoomBox').panzoom({
                    startTransform: 'scale(1.1)',
                    minScale: 1.0,
                    maxScale: 5.0,
                    increment: 0.5
                }).panzoom('zoom', true);
                    
                    
                $('#photoZoomBox').parent().on('mousewheel.focal', function( e ) {
                    e.preventDefault();
                    var delta = e.delta || e.originalEvent.wheelDelta;
                    var zoomOut = delta ? delta < 0 : e.originalEvent.deltaY > 0;
                    $('#photoZoomBox').panzoom('zoom', zoomOut, {
                        increment: 0.1,
                        animate: false,
                        focal: e
                    });
                });
                */ 
            });
               
            $('.zoomout').off('click keypress');  
            $('.zoomout').on('click keypress', function(e) {
                if (e.type =='keypress' && !(e.which == 13)) { return;}
                e.preventDefault();
                $(".zoomout").addClass("hide");
                $(".zoomin").addClass("showOnSmall").removeClass("hide");
                $(".zoomDescription").addClass("hide");
                cleanExtraZoom();
                cleanMainZoom();
                   // $('#photoZoomBox').panzoom("reset", true);      
                    //setTimeout(function () {
                    //    $('#photoZoomBoxParent').hide();
                    //    $('#photoZoomBox img').attr({
                    //            src: '',
                    //            alt: 'Product zoom image'
                     //   });
                     //   $('#photoSwipeBoxWrapper').show();
                    //}, 300);
                // $("#photoSwipeBox").slick("slickGoTo", slider.currentSlide);
            });
        }
    }
	

    MobileTweaks();
	function FixIE11SVG(){
		var isIE11 = !!navigator.userAgent.match(/Trident\/7\./); 
		
		if(isIE11){	
			var svgs = document.getElementsByTagName("svg");
			var i = svgs.length;
			while (i--) {
				svgs[i].setAttribute("focusable", "false");
			}
		}
	}
  	
  	// 360 guarantee
  	if($('#div360dialog').length){
  		var guaranteeDialog = dialog4i();
		guaranteeDialog.init(document.getElementById('div360dialog'), document.getElementsByClassName('the360link'));
	
  	}
  	$(".the360link").on("click", function(e){
		e.preventDefault();
		lazyloadImages.update();
	});
  	
	function GetQty(){
		if (!isApparelItem) {
            		return parseInt($("#txtQty").val());
        	} else { 
            		return parseInt($("#txtQty").html());
        	} 	
	}
    //check for google feed
    var qryStr = window.location.search;
    qryStr = qryStr.indexOf("gfeed=1");
    function CheckQueryString(){
    	if (qryStr > 0) {
    		var txtQty = GetQty();
		var selBaseTrim = $('.selectedColorID').first().val(); 
		var glideUnitPrice = 0;
		var glideTotal = 0;
		glideUnitPrice = $('#lblPrice').html();
		glideTotal = $('#lblTotal').html();
		
		$('#GFeedQty').html(txtQty);
		$('#GFeedUnitPrice').html(glideUnitPrice);	       
		$('#GFeedTotalPrice').html(glideTotal); 
		SaveImprintColor($('#gFeedDefaultImprintColor').siblings('.spnColorChip'));
		
		if (optionalExtras == null) { LoadOptionalExtras(); }
		if (nibInkOptions == null) { LoadNibInkColor();  }
		if (adhSidesOptions == null) { LoadAdhesiveOptions();  }
		GetExtras($('#GFeedData')); 
		}
    }
    //end google feed
    
    //calculate the width of the reviews, ss, customer photos, q&a, fit rating tabs
    function detailTabWidth(){
    	var isApparel = isApparelItem;
    	var isNotApparel = !isApparelItem;
    	var isMobile = $('.contactPanel').css('display') == 'none';
    	var isDesktop = $('.prodNumber').css('float') == 'none';
    	var isTabMobile = $('.prodNumber').css('float') == 'left';
    	var isTabletDesktop = $(".contactPanel").css("display") == 'block';
    	var showCustomerImages = localizedJS.showCustomerImages;
	  var w;
        if (isMobile && isNotApparel && showCustomerImages){
            $('#fitRatingTS').hide();
            $("#reviewsTS").css("width", "27%");
        	$("#successStoriesTS").css("width", "26%");
        	$("#customerImagesTS").css("width", "25%");
        	$("#QATS").css("width", "22%");
            $('.detailsTabArrow').hide();
        }
        else if (isMobile && isApparel && showCustomerImages){
        	$('.detailsTabArrow').hide();
            $("#reviewsTS").css("width", "24%");
        	$("#successStoriesTS").css("width", "22%");
        	$("#customerImagesTS").css("width", "22%");
        	$("#QATS").css("width", "20%");
        	$('#fitRatingTS').css("width", "12%");
        	$('.detailsTabSelect h2').addClass('paddingTop10 paddingBtm10 padding5')
        						.removeClass('padding10');
           	
        }
        else if (isMobile && isNotApparel){
            $('#customerImagesTS').hide();
            $('#fitRatingTS').hide();
            $('.detailsTabArrow').hide();
            $('.detailsTabSelect').width('33%');
            
        }
        else if (isMobile){
        	$('.detailsTabArrow').hide();
        	$('#customerImagesTS').hide();
          	$('.detailsTabSelect').width('100%');
        }
        else if (isTabletDesktop && isApparel && showCustomerImages){
            w = (100/5);
            $('.detailsTabSelect').width(w+'%');
        }
        else if (isTabletDesktop && isNotApparel && showCustomerImages){
            $('#fitRatingTS').hide();
            w = (100/4);
            $('.detailsTabSelect').width(w+'%');
        }
        else if (isTabletDesktop && isApparel){
            $('#customerImagesTS').hide();
            w = (100/4);
            $('.detailsTabSelect').width(w+'%');
        }
        else if (isTabletDesktop && isNotApparel){
            $('#customerImagesTS').hide();
            $('#fitRatingTS').hide();
            w = (100/3);
            $('.detailsTabSelect').width(w+'%');
        }
        
        if (isApparel && showCustomerImages) {
        	detailTabResizeText();
        }
    }
    
    
    //resize text of detail tabs when window is resized (only if product is apparel)
    function detailTabResizeText() {
        if (window.innerWidth >= 1030) {
            $('.detailsTabSelect h2').addClass('text18');
            $('.detailsTabSelect h2').removeClass('text16');
        }
        else if (window.innerWidth >= 600) {
            $('.detailsTabSelect h2').addClass('text16');
            $('.detailsTabSelect h2').removeClass('text18');
        }
        else if (window.innerWidth < 600) {
            $('.detailsTabSelect h2').addClass('text18');
            $('.detailsTabSelect h2').removeClass('text16');
        }
    }
	
    //save product color
    function SaveProdColor(triggerElement) {
        $('.errorMsg').remove();
        var selectedImg = $(triggerElement).find('img').attr('src');
        if (!selectedImg)
        	selectedImg = $(triggerElement).attr('src');
    	 if (!selectedImg)
    	 	selectedImg = $(triggerElement).attr('data-lazy');
 	if (!selectedImg && recolorAvailable == "True" )
    	 	selectedImg = $(triggerElement).parent().attr('href').replace("rend/700", "rend/300");
        var selectedBaseTrimID = "";
        var selectedColorName = "";
        var trimColorHex = "";
        var baseColorHex = "";
        //$("#photoSwipeBox").royalSlider('goTo', 0);
         $("#photoSwipeBox").slick('slickGoTo', 0);
        if (recolorAvailable == "True") {
            $('.imgBox').each(function () {
                $(this).children('a').children('.selectedImgDesc').addClass('textDarkestGray').removeClass('bkgdBlue').children('.selectedImgOutOfStockDesc').addClass('textRed').removeClass('textWhite');
                $(this).removeClass('imgActive');
            });
		
            $(triggerElement).siblings('.selectedImgDesc').addClass('textWhite bkgdBlue').removeClass('textDarkestGray').children('.selectedImgOutOfStockDesc').addClass('textWhite').removeClass('textRed');
            $(triggerElement).parent().parent('.imgBox').addClass('imgActive');
            if (selectedImg) selectedImg = selectedImg.replace("rend/60", "rend/300");
            $('#hypProdImg .mainProdImg').attr("src", selectedImg);
            
            if (selectedImg) {
            	selectedImg = selectedImg.replace("rend/300", "rend/700");
            	$('#hypProdImg').attr("href", selectedImg);
            	if(!isMobile){
            		cleanMainZoom();
            		loadMainZoom();
            	}
            }
            
            $('#colorSelected').val($(triggerElement).attr("title"));
            selectedBaseTrimID = $(triggerElement).parent().siblings('.selectedColorID').val();
            $('#colorSummary').text($(triggerElement).attr('title'));
            selectedColorName = $(triggerElement).parent().siblings('.selectedColorName').val();
            baseColorHex = $(triggerElement).parent().siblings('.baseColorHex').val();
            trimColorHex = $(triggerElement).parent().siblings('.trimColorHex').val();
        }
        else {
            selectedBaseTrimID = $(triggerElement).children('.selectedColorID').val();
            selectedColorName = $(triggerElement).children(".selectedColorName").val();
            baseColorHex = $(triggerElement).children('.baseColorHex').val();
            trimColorHex = $(triggerElement).children('.trimColorHex').val();

            $('.prodImgSelected').each(function () {
                $(this).find('.selectedImgDesc').addClass('textDarkestGray').removeClass('bkgdBlue').children('.selectedImgOutOfStockDesc').addClass('textRed').removeClass('textWhite');
            });

            $(triggerElement).find('.selectedImgDesc').addClass('textWhite bkgdBlue').removeClass('textDarkestGray').children('.selectedImgOutOfStockDesc').addClass('textWhite').removeClass('textRed');
        }

        $('#baseSpan').css('background-color', '#' + baseColorHex);
        $('#trimSpan').css('background-color', '#' + trimColorHex);

        if (selectedBaseTrimID != undefined && selectedBaseTrimID != "") {
        	$('.CheckMarkProdColor').removeClass('textMdGray');
            $('.CheckMarkProdColor').addClass('textGreen');
            selBaseTrim.val(selectedBaseTrimID);
            $('#colorSelected').val(selectedColorName);
            $('#selColors').html(selectedColorName);
        }

        if (!isApparelItem) {
            $('.step1').removeClass('disabledBtn').addClass('bkgdBlue whiteLink');
            if(isMobile){
            	LoadOptionalExtras();
                LoadNibInkColor();
                LoadAdhesiveOptions();
           
                if (qryStr > 0){
                	CheckQueryString();

                	var gFeedSummary = '<div class="GFeedPanel1">';
                	gFeedSummary += $('#GFeedPanel').html() + '</div>';
                	$('#GFeedPanel').html('');

                	if(totalImprintColors > 0){
                		$('.chkbxImprintLocation:checked').first().parent().parent().find('.imprintButtonExtras').addClass('hide').after(gFeedSummary);
                	} else{
                		$('.imprintButtonExtras').addClass('hide').after(gFeedSummary);
                	}
                }
                ValidateCustomizeSections();
            }
        }

        if (selectedBaseTrimID != '' && isApparelItem) {
            //Load apparel size grid
            $('#PD_SizeGrid').html('');
            $('#PD_SizeGridLoading').show();
            $('.PD_QuantityBtnCell input').attr('disabled', 'disabled').css('opacity', 0.3);// Disables the qty button to keep it from opening multiple windows
            $('.PD_SizeChoicePanel').fadeIn('fast');//.centerInClient();
            
		    var hidePricing = $('#HideAdvertisedPrice').val().toUpperCase() === 'TRUE' ;
            
            $.ajax({
                url: '/productmvc/loadsizeoptions',
                type: 'POST',
                data: { 'ProductID': prodID, 'Color': selectedBaseTrimID, 'EditID': editID, 'HidePricing' : hidePricing},
                datatype: 'html',
                beforeSend: function () {
                    $('.sizeGridLoadingImg').fadeIn('fast', function () { });
                },
                complete: function () {
                    $('.sizeGridLoadingImg').hide('fast', function () { });
                    CheckQueryString();
                     $('#GFeedPanel').show();
                },
                timeout: 20000,
                success: function (data) {
                    $('#PD_SizeGridLoading').hide(); // Hide the loading image
                    $('#SizingGrid').html(data);
                    //RenderToolTips();
                    tooltips.init();
                    if(editID < 0 && qryStr > 0){
                    	$('.txtApparelQty').first().val(lowestQty);
                    }
                    CalcPrice();
                    if(hidePricing){ 
                    		$('.showp').addClass('hide');
                    		$('.showpm').removeClass('hide');
                    }
                },
                error: function () {
                    $('#PD_SizeGridLoading').hide();
                    $('#SizingGrid').html('<div role="alert" class="margin10 padding10 borderDkRed textDkRed clear">An error occured when looking up the available sizes. Please select ' + localizedJS.Color + ' again, or call us toll free at ' + localizedJS.PhoneNumber + ' for further assistance.</div>');
                }
            });
        }
    }
    //end product color
    
    //show color option window
    function showColorOptions() {
        $('#colorOptions').show();
        $('#colorOptions').attr('aria-hidden', 'false');
        $('#selectBaseColor').show();
        $('#selectBaseColor').attr('aria-hidden', 'false');
        $('#prodColorCountContainer').hide();
        $('#prodColorCountContainer').attr('aria-hidden', 'true');
        $('#productColorScroller').hide();
        $('#productColorScroller').attr('aria-hidden', 'true');
        $('#jumpToColor').hide().attr('aria-hidden', 'true');
        tooltips.init();
    }
    //end show color options

    //jump to a color
    function jumpToColor(triggerElement, focus) {
        var chosenColorID = '';
        if ($(triggerElement).is('#removeColorFilter')) {
            chosenColorID = '-1';
        }
        else if ($(triggerElement).hasClass('colorOption')) {
            chosenColorID = triggerElement.id.replace('colorOption', '');
        }
        else {
            chosenColorID = triggerElement.parentNode.id.replace('colorOption', '');
        }
	
        $.ajax({
            url: '/product/productcoloroptions',
            type: 'post',
            data: $('form').serialize() + '&chosenColorID=' + chosenColorID,
            success: function (result) {
            		
		   colorOptionsClicksOff();
                prodColorScrollerOff(); 
                $('#productColors').html(result);
		   colorOptionsClicks();                  
                initProductColorScroller();
                
                if (focus) {
                	$('#productColorScroller').find('.imgBox').first().find('.selectedImgDesc').focus();
                }
                
                if($('#productColorScroller .slick-slide').length == 1){
	    		$('.prodImgSelected').click(); 
    		   }
    		   tooltips.init();
            }
        });
    }
    
    //end jump to color
    
    //bind clicks and keypresses for product color options
    function colorOptionsClicksOff(){
    	$('#jumpToColor').off();
    	$('.colorOption').off();
    	$('#removeColorFilter').off();
    }
    
    function colorOptionsClicks() {
    	$('#jumpToColor').on("click", function(e) 	{ 
    		
		//if (e.type =='keypress' && !(e.which == 13)) { return;}
		    e.preventDefault();
    		showColorOptions(); 
    		$('#colorOptions').find('.colorOption').first().focus();
    	});
	    
	$('.colorOption').on("click", function(e) { 
		
		//if (e.type =='keypress' && !(e.which == 13)) { return;}
		e.preventDefault();
		jumpToColor(this, (e.which == 13));

	});
	
	$('#removeColorFilter').on("click", function(e) { 
		
		//if (e.type =='keypress' && !(e.which == 13)) { return;}
		e.preventDefault();
		jumpToColor(this, (e.which == 13));
	    	
	});
    }
    //end color options clicks
    
    colorOptionsClicks();
    
    //init product color scroller after jumpToColor
    function prodColorScrollerOff(){
    
        $('#productColorScroller').off();
        $('.prodImgSelected').off();
           
    }
    
    function initProductColorScroller(){ 
        
        prodScrollerJS.InitProductColorScroller();
        
        $('#productColorScroller').on('click', '.slick-slide', function(e){
            //if (e.type =='keypress' && !(e.which == 13)) { return;}
            e.preventDefault();
            e.stopPropagation();
            var triggerImg = $(this).find('.prodImgSelected');
            SaveProdColor(triggerImg);
        });
        
        $('.prodImgSelected').on('click', function(e){
            //if (e.type =='keypress' && !(e.which == 13)) { return;}
            e.preventDefault();
            e.stopPropagation();
            SaveProdColor(this); 
        });
        
        $('.imgBox a').on('click', function(e){
            //if (e.type =='keypress' && !(e.which == 13)) { return;}
            e.preventDefault();
            e.stopPropagation();
            var triggerImg = $(this).find('.prodImgSelected');
            SaveProdColor(triggerImg); 
        });
	
       //$('.imgBox a').attr('tabindex', '-1');
    }
    //end init product color scroller
    
    initProductColorScroller();
    
    
    //save imprint color
    function SaveImprintColor(triggerElement) {
        ResetImprintCharges();
        
        $('.errorMsg').remove();
        var selectedColor = $(triggerElement).css('background-color');
        var colorTitle = $(triggerElement).attr('title');
        var imprintLocID = $(triggerElement).siblings('.imprintLocationID').val();
        var imprintColorID = $(triggerElement).siblings('.imprintColorID').val();
        var productImprintLocationID = $(triggerElement).siblings('.productImprintLocationID').val();
        var child;
        var oneColor = true;
	 
        $('.' + imprintLocID).children('.colorList').each(function () {
            var rgbColor = $(this).children('.imprintColorBox').css('backgroundColor');
            if (rgbColor == "rgba(0, 0, 0, 0)" || rgbColor == "transparent") {
                child = $(this).children('.imprintColorBox');
                //$(this).children('.imprintColorBox').html('');

                $(this).children('.imprintLocationID').val(imprintLocID);
                $(this).children('.imprintColorID').val(imprintColorID);
                $(this).children('.productImprintLocationID').val(productImprintLocationID);

                //$(this).children('.imprintColorBox').html(child);
                $(this).children('.imprintColorBox').css("background-color", selectedColor);
                $(this).children('.imprintColorBox').prop('title', colorTitle);
                $(this).find('a.imprintClearColor').focus();
                oneColor = false;
                return oneColor;
            }
        });

        if (oneColor) {
            child = $('.' + imprintLocID).children('.colorList').first().find('.imprintColorBox');
            //$('.' + imprintLocID).children('.colorList').first().children('.imprintColorBox').html('');
            //$('.' + imprintLocID).children('.colorList').first().children('.imprintColorBox').html(child);
            $('.' + imprintLocID).children('.colorList').first().children('.imprintColorBox').css("background-color", selectedColor);
	     $('.' + imprintLocID).children('.colorList').first().children('.imprintColorBox').prop('title', colorTitle);
	     $('.' + imprintLocID).children('.colorList').first().children('a.imprintClearColor').focus();
	     
            $('.' + imprintLocID).children('.colorList').first().children('.imprintLocationID').val(imprintLocID);
            $('.' + imprintLocID).children('.colorList').first().children('.imprintColorID').val(imprintColorID);
            $('.' + imprintLocID).children('.colorList').first().children('.productImprintLocationID').val(productImprintLocationID);
        }

        ValidateCustomizeSections();

    }
    //end save imprint color

    //close color picker
    function CloseColorPicker(triggerElement) {
        $(triggerElement).parent('.imprint-colors-content').toggle('slow');
    }//end color picker

    //QA
    function initQAPages() {
        $('.qapageselect').each(function () {
        	 $('#' + this.id).off();
          	 $('#' + this.id).on("click keypress", function (e) {
                if (e.type =='keypress' && !(e.which == 13)) { return;}
                //fitRatingFilter
                var vals = this.id.split('_');
                var page = vals[1];
                loadingPage();
                $.ajax({
                    url: "/productmvc/qandapage/" + prodID + "/" + page,
                    type: "GET",
                    contentType: 'application/json',
                    dataType: 'html',
                    success: function (result) {
                        $('#QandAPage').html('');
                        $('#QandAPage').html(result);
                        hideLoading();
                        initQAPages();
                        ScrollToElement("#QandAContainer");
                    },
                    error: function(){
                    	hideLoading();
                    }
                });
            });
        });
    }
    //returns whether or not the extras should be reloaded
    function ResetImprintCharges() {
        //$('.extrasResult').fadeOut('slow').html('');
        $('.calcExtrasBtn').val('Show Imprint Charges');
        var isHidden = $('.extrasResult').css('display') == 'none';    
        $('.extrasResult').html('').hide();
        return !isHidden;
        
    }

    //GRABS ALL SELECTED IMPRINT LOCATION AND COLORS AND SETS THEM IN PRODUCT SUMMARY AFTER ADD TO CART
    function SetSummaryImprintColors() {
        var newContent = "";
        if (listSelectedImprintLocationName.length > 0 && listSelectedColorsRGB.length > 0 && totalImprintColors > 0) {
            for (var i = 0; i < listSelectedImprintLocationName.length; i++) {
                newContent += "<div class='clear tinySpace'></div><h5 class='textsemibold'>Imprint Location</h5>" +
    					"<p>" + listSelectedImprintLocationName[i] +
    					"</p><div class='clear tinySpace'></div><h5 class='textsemibold'>Imprint " + localizedJS.ColorCap + "(s)</h5>";
                for (var j = 0; j < listSelectedColorsRGB[i].length; j++) {
                    newContent += "<div class='imprintColorSummary floatLeft marginTop5 marginBtm20 marginRight5 borderDkGray' style='background-color: " + listSelectedColorsRGB[i][j] + "'></div>";
                }
            }
        } else if (totalImprintColors == 0) {
            for (var i = 0; i < listSelectedImprintLocationName.length; i++) {
                newContent += "<div class='clear tinySpace'></div><h5 class='c-sm-quarter-2 c-xs-full floatLeft textsemibold'>Imprint Location</h5>" +
    					"<div class='c-sm-quarter-2 c-xs-full floatLeft'><p class='floatRightOnMedium'>" + listSelectedImprintLocationName[i] +
    					"</p></div><div class='clear'></div>";
            }
        }

        $('.imprint-location-summary').prepend(newContent);
    }//END IMPRINT LOCATION AND COLORS


    //VALIDATE ALL ITEM CUSTOMIZATION STEPS AND ACTIVATE ADD TO CART BUTTON
    function ValidateCustomizeSections() {
        GetSelectedImprintLocations();
        GetSelectedImprintColors();

        //because of design decision to show everything at once, need to make sure they've selected a product color
        if (isMobile){
            if($('#colorSelected').val() === ''){
                $('.btnAddToCart').removeClass('bkgdRed whiteLink').addClass('disabledBtn bkgdDkGray');
                return false;
            }
        }

        if (listImprintLocationIDs.length > 0) {
            if (listSelectedColors.length == 0 && totalImprintColors > 0) {
                if ($('.CheckMarkImprintLoc > span').hasClass('textGreen')) {
                    $('.CheckMarkImprintLoc > span').removeClass('textGreen');
                    $('.btnAddToCart').removeClass('bkgdRed').addClass('disabledBtn');
                    $('.btnAddToCart').removeClass('whiteLink');
                }
            } else {
                $('.CheckMarkImprintLoc').children('span').addClass('textGreen');
                $('.btnAddToCart').removeClass('disabledBtn bkgdDkGray').addClass('bkgdRed whiteLink');
                //$('.btnAddToCart').addClass('whiteLink');
            }
        } else {
            if ($('.CheckMarkImprintLoc > span').hasClass('textGreen')) {
                $('.CheckMarkImprintLoc > span').removeClass('textGreen');
                $('.btnAddToCart').removeClass('bkgdRed whiteLink').addClass('disabledBtn bkgdDkGray');
                //$('.btnAddToCart').removeClass('whiteLink');
            }
        }

        

        
    }//END VALIDATION

    function GetSelectedImprintLocations() {
        listImprintLocationIDs = [];
        listProductImprintLocationIDs = [];
        if (totalImprintColors == 0) {
            listSelectedImprintLocationName = [];
        }

        $('.chkbxImprintLocation').each(function () {
            if ($(this).prop('checked')) {
                var x = [];
                var inputImpLocID = $(this).siblings('.imprintLocationID').val();
                var imprintLocationName = $(this).siblings('.imprintLocationName').val();
                var impl = null;
                var prodimploc = null;
                var imprintColorsFound = $(this).parent().siblings('.imprintColorsFound').val();

                if (totalImprintColors == 0) {
                    listImprintLocationIDs.push(inputImpLocID);
                    listSelectedImprintLocationName.push(imprintLocationName);
                }
                else {
                    if (imprintColorsFound == undefined || imprintColorsFound == '') {
                        $('.' + inputImpLocID).children('.colorList').each(function () {
                            var imprintLocationID = $(this).children('.imprintLocationID').val();
                            var imprintColorID = $(this).children('.imprintColorID').val();
                            var productImprintLocationID = $(this).children('.productImprintLocationID').val();
                            if (imprintLocationID != undefined && imprintColorID != undefined && productImprintLocationID != undefined) {
                                if (imprintLocationID != "" && imprintColorID != "" && productImprintLocationID != "") {
                                    impl = imprintLocationID;
                                    prodimploc = productImprintLocationID;
                                }
                            }
                        });
                    } else {
                        impl = inputImpLocID;
                    }

                    if (impl != null) {
                        listImprintLocationIDs.push(impl);
                    }
                    if (prodimploc != null) {
                        listProductImprintLocationIDs.push(prodimploc);
                    }
                }
            }
        });
    }

    //GET ALL SELECTED SIZES AND THEIR QUANTITY FOR APPAREL PRODUCT
    function GetSelectedSizes() { 
        var sizeHash = "";
        if (isApparelItem) {
            $('.sizeOptionQty').each(function () {
            	var sizeQty = $(this).find('.txtApparelQty ').val();
            	if(sizeQty != '' && sizeQty != undefined){
            		var saPID = $(this).find('.sizeAttrProdID').val();
            		var saID = $(this).find('.sizeAttrID').val();
            		var qty =  $(this).find('.txtApparelQty ').val();
            		sizeHash +=  saPID + '-' + saID + '-' + qty + '|';
            	}                           
            });
        }
        return sizeHash;
    }

    //get optional extras
     function LoadOptionalExtras() {
        var qty = GetQty();

        $.ajax({
            type: "POST",
            url: "/productattribute/optionalextras",
            data: { 'ProductID': prodID, 'Quantity': qty },
            dataType: "html",
            timeout: 15000,
            success: function (data) {
                optionalExtras = data;
                var parsedData = JSON.parse(data);

                if (parsedData != null && parsedData.extras.length > 0) {
                    var ExtrasText = "";

                    for (var i = 0; i < parsedData.extras.length; i++) {

                        // determine if the checkbox should be checked
                        var checkit = "";
                        if (editID > 0) {
                            if ($('.SelectedOptionalExtras').val().indexOf('*' + parsedData.extras[i].id + ',') != -1) {
                                checkit = " checked = 'checked'";
                                UpdateOptionalExtraPrice(); // set price in "Current Selection" section
                            }
                        }

                        var unitprice = parsedData.extras[i].unitprice;
                        var qty = $('.selectedQty').html();
                        var totalprice;
                        if (!isNaN(unitprice)) { totalprice = (unitprice * qty).toFixed(2); }
                        ExtrasText += "<div class='imprintLocCheck clear'>";
                        ExtrasText += "<input type='checkbox' value='" + parsedData.extras[i].id + "' id='opt" + parsedData.extras[i].id + "' name='opt" + parsedData.extras[i].id + "' onchange='AddSelectedExtra(this)'" + checkit + " />";
                        ExtrasText += "<label for='opt" + parsedData.extras[i].id + "'>" + parsedData.extras[i].displayname + "</label>";
                        if (!isNaN(totalprice)) { ExtrasText += " - <span>For an Additional " + currencySymbol + totalprice + " (" + FormatMoneyUS(parsedData.extras[i].unitprice) + " per piece)</span><br />"; }
                        ExtrasText += "<span class='textDarkestGray paddingLeft10 text14'>(" + parsedData.extras[i].displaydesc + ")</span>";
                        ExtrasText += "</div>";
                    }

                    $('#haloOptions').html(ExtrasText);
                    $('#PD_OptionalExtra').show();
                }
            },
            error: function () {
                $('#PD_OptionalExtra').hide();
            }
        });
    } 
    //end optional extras

    //add extra
    AddSelectedExtra = function (cb) {
	$('.GFeedPanel1').remove();
        var currentselection = $('#SelectedOptionalExtras'); // this holds all the selected extras in '*11, *33,'
        if (cb.checked) {
            if (currentselection.val().indexOf('*' + cb.value + ',') == -1) {
                newExtra = currentselection.val() + '*' + cb.value + ',';
                currentselection.val(newExtra);
                
            }
        } else {
            // remove from if is there
            if (currentselection.val().indexOf('*' + cb.value + ',') != -1) {
                currentselection.val(currentselection.val().replace('*' + cb.value + ',', ''));
                $('#selectedOptionalExtraResult').hide();
                return false;
            }
        }

        $('.optionalExtrasLoadingImg').show();
        $('#selectedOptionalExtraResult').hide();
        //$('#SelectedOptionalExtras').val(currentselection);
        UpdateOptionalExtraPrice(); // add to the total
        //ResetCalcExtras(); // update the other extras total
    };

    function UpdateOptionalExtraPrice() {
        var qty = GetQty();
        $.ajax({
            type: "POST",
            url: "/productattribute/optionalextras",
            data: { 'ProductID': prodID, 'Quantity': qty },
            dataType: "html",
            beforeSend: function () {

            },
            complete: function () {
                $('.optionalExtrasLoadingImg').hide();
            },
            timeout: 15000,
            success: function (data) {

                var parsedData = JSON.parse(data);
                if (parsedData != null && parsedData.extras.length > 0) {
                    var ExtrasText = "";
                    var totalprice = parseFloat($('#lblTotal').html().replace(currencySymbol, '').trim());
                    for (var i = 0; i < parsedData.extras.length; i++) {
                        var currentselection = $('#SelectedOptionalExtras').val();
                        if (currentselection.indexOf('*' + parsedData.extras[i].id + ',') != -1) { // check here if extraID is in .SelectedOptionalExtras
                            var qty = GetQty();
                            var unitprice = parseFloat(parsedData.extras[i].unitprice);
                            var optionaltotal = qty * unitprice;
                            totalprice = totalprice + optionaltotal;

                            ExtrasText += "<div class='extraDetailsLine padding10 text14'>";
                            ExtrasText += "<div class='inlineMiddle noPadding c-sm-third-2 c-xs-full textsemibold'>" + parsedData.extras[i].displayname + "</div>";
                            //ExtrasText += "<div class='floatRight extraDetailsNumCol marginLeft10'> " + currencySymbol + optionaltotal.toFixed(2) + "</div>";
                            ExtrasText += "<div class='inlineMiddle noPadding c-sm-third-1 c-xs-full'><p class='floatRightOnMedium'>" + GetQty() + "  @  " + currencySymbol + unitprice.toFixed(2) + " each = " + currencySymbol + optionaltotal + "</p></div>";
                            ExtrasText += "</div>";
                        }
                    }

                    if (totalprice != parseFloat($('#lblTotal').html().replace(currencySymbol, '').trim())) {
                        // only need to show this if the total price is different from the quantity selected price
                        $('#grandTotal').html(totalprice);
                    }

                    $('#selectedOptionalExtraResult').html(ExtrasText);
                    $('#selectedOptionalSummary').html(ExtrasText);
                    $('#selectedOptionalExtraResult').show();

                }
            },
            error: function () {
            }
        });
    }

    function ResetCalcExtras() {
        $('.extrasLoadingImg').hide();
        $('.extrasResult').slideUp('fast', function () {
            $('.calcExtrasBtn').fadeIn();
        });
        $('#selectedExtras').slideUp('fast');
    }
    //end add extra

    //scroll to element
    function ScrollToElement(selector, time, verticalOffset) {
        time = typeof (time) != 'undefined' ? time : 1000;
        verticalOffset = typeof (verticalOffset) != 'undefined' ? verticalOffset : 0;
        element = $(selector);
        offset = element.offset();
        offsetTop = offset.top + verticalOffset;
        $('html, body').animate({
            scrollTop: offsetTop
        }, time);
    }
    
    //end scroll to element

    //calcualte extra upcharges
    function GetExtras(triggerElement) {
        var chkdImprintLoc = 0;
        $('.chkbxImprintLocation').each(function () {
            if ($(this).is(':checked')) {
                chkdImprintLoc++;
            }
        });

        if (chkdImprintLoc > 0) {
            var qty = GetQty();

            GetSelectedImprintColors();
            GetSelectedImprintLocations();

            if (listImprintLocationIDs.length == 0 || listProductImprintLocationIDs.length == 0 || listSelectedColors.length == 0) {
                $('.PD_Step_2').find('.errorMsg').remove();
                if (totalImprintColors > 0) {
                    $('.imprint-location').first().before('<p class="textDkRed errorMsg borderDkRed padding10 marginTop15 marginBtm15 textsemibold" role="alert">Please select at least one imprint location and one imprint ' +  localizedJS.Color + '</p>');
                    ScrollToElement('.PD_Step_2');
                    return false;
                }
            }

            var arrImprintLocationIDs = listImprintLocationIDs;
            var arrProductImprintLocationIDs = listProductImprintLocationIDs;
            var arrImprintColorsIDs = listSelectedColors;
            var adhesiveAttributeID = $('#adhSideOptions').find('input:checked').siblings('input').val();
            var nibColorAttributeID = $('#inkColorOptions').find('input:checked').siblings('input').val();
            var baseTrimColor = selBaseTrim.val().split('/');
            if (adhesiveAttributeID == "") {
                adhesiveAttributeID = undefined;
            }
            var OrderSummary = {
                ProductID: prodID, Quantity: qty, ImprintColors: arrImprintColorsIDs, ImprintLocations: arrImprintLocationIDs, BaseColorID: baseTrimColor[0], TrimColorID: baseTrimColor[1],
                EditID: editID, ProductImprintLocations: arrProductImprintLocationIDs, NibColorAttributeID: nibColorAttributeID, AdhesiveAttributeID: adhesiveAttributeID
            };

            $.ajax({
                type: "POST",
                url: "/productmvc/calculateextras",
                data: JSON.stringify(OrderSummary),
                dataType: "html",
                contentType: "application/json",
                beforeSend: function (req) {
                    //$('.calcExtrasBtn').fadeOut('fast');
                    $(triggerElement).siblings('.extrasLoadingImg').fadeIn('fast');
                    ResetImprintCharges();
                },
                complete: function (req) {
                    $(triggerElement).siblings('.extrasLoadingImg').fadeOut('fast');
                    //ExtrasComplete();
                },
                //done: function(){ ExtrasComplete();  },
                success: function (data) {
                    if (data.indexOf('extrasError') < 0) {
                        $('#setupChrgSummary').html(data);
                    } else {
                        $('#setupChrgSummary').html('<p class="textsemibold" role="alert">Add To Cart To View Any Imprint Charges</p>');
                    }

                    $(triggerElement).siblings('.extrasResult').html(data + "<div class='clear'></div>");
                    //RenderToolTips();
                    tooltips.init();
                    $(triggerElement).siblings('.extrasLoadingImg').fadeOut('fast', function () {
                        $(triggerElement).siblings('.extrasResult').slideDown('fast');
                    });

                    var ExtraTemplate = $('#selectedExtrasBox').children('.selectedExtraLine').eq(0);
                    var ExtrasTotal = 0.00;
                    var Extras = $(document.createElement("div")).attr('id', 'ExtraDummy');
                    $('#setupChrgSummary').children('.extraDetailsLine').each(function () {
                        var NewExtra = ExtraTemplate.clone(false);
                        var LineTotal;
                        var LinePrice;
                        var LineQty;
                        $(this).find('span.LineTotal').each(function (e) {
                            LineTotal = $(this).html();
                        });

                        if (LineTotal != undefined && LineTotal != "") {
                            ExtrasTotal += parseFloat(LineTotal.replace(LineTotal.substring(0, 1), ''));
                        }
                        NewExtra.children('.selectionExtraDesc').html($(this).children('div.extraDetailsDescCol').html());
                        if (LinePrice == '' || LineQty == '') {
                            NewExtra.children('.selectionExtraQtyPrice').html('');
                        } else {
                            NewExtra.children('.selectionExtraQtyPrice').html(LineQty + ' @ ' + LinePrice);
                        }

                        NewExtra.appendTo(Extras);
                    });

                    currencySymbol = currencySymbol.replace(/\s+/g, '');
                    var totalDisplayed = $('#lblTotal').html();
                    totalDisplayed = totalDisplayed.replace(/\s+/g, '');
                    var total = (ExtrasTotal + parseFloat(totalDisplayed.replace(totalDisplayed.substring(0, 1), ''))).toFixed(2).toString();
                    $('#currencySymbol').html(currencySymbol);
                    $('#grandTotal').html(total);
                    $('#GFeedBasePrice').html(currencySymbol + ExtrasTotal);
                    if (qryStr > 0) { 
				if(ukTaxRate != '0'){
					//UK locale, add VAT				
            			$('#VatTax').html(currencySymbol + localizedJS.VatTax(ExtrasTotal, totalDisplayed.replace(currencySymbol, ''), ukTaxRate));
            			$('#GFeedFinalPrice').html(currencySymbol + localizedJS.TotalWithVat(ExtrasTotal, totalDisplayed.replace(currencySymbol, ''), ukTaxRate));
            		} else{
            			//Not UK
            			$('#GFeedFinalPrice').html(currencySymbol + total);
            		}
        		   }
                },
                error: function () {
                    $(triggerElement).siblings('.extrasLoadingImg').fadeOut('fast');
                    $(triggerElement).siblings('.extrasResult').html('<div role="alert">Sorry, an error occurred. Please <a href="#" onclick="return GetExtras();">click here</a> to try again. You can also view the imprint charges in your cart by click the Add to Cart button below.</div>');
                }
            });
        }
        return false;
    }
    //end extra charges
    
   var cartUrl = '';
	function DisplayRestricted(cartID, cartItemID){		
		var restrictedPricingDialog = dialog4i();
		restrictedPricingDialog.init(document.getElementById('restrictedPricingProduct'));
		
		loadUserLinks();
    		var productName = $(".prodName").text();
    		var productNameNoQuote = productName.replace(/'/g,"");
    		$("<img id='restrictedProductImg' src='" + $("#hypProdImg").attr("href") +"' alt='"+ productNameNoQuote + "' class='responsiveImg'>").appendTo($("#imgforrestricted"));
    	
    		
    	
    		$(".prodNameRestricted").text(productName);
    	    	
	    	if(isApparelItem){
			$('#priceTblSizeChoice').appendTo($('#pricingArea'));
	    		$('#priceTblSizeChoice').removeClass("hide");
	    		$('#sizingBox').appendTo($('#pricingArea'));
	    		$('#litGlideDesc').addClass('hide');
	    		$('#pnlFitRating').addClass('hide');   		
	    	}else{
	    		$('.glide').appendTo($('#pricingArea'));
	    		$(".layout-slider").css("width", "100%");
    		}
    	
    		$('.showp').removeClass('hide');
    		$('.showpm').addClass('hide');
		$("#restrictedPricingProduct").attr("data-cart-item", cartItemID);
		restrictedPricingDialog.open();
		$("#btnGoToCart").focus();
		$('.cartLoadingImg').hide();
		
		$("#restrictedPricingProduct .close4iDialog").on("click", function(e){
			e.preventDefault();
			loadUserLinks();
			if(isApp){
		    		$('#sizingBox').appendTo($('#pnlSizing'));
		    		//$("#pricingarea > #sizingBox").remove();
		    	}else{
		    		$('.glide').appendTo($('.glidePanel'));
		    	}
		    	$("#restrictedPricingProduct").attr("data-cart-item", ""); 
	    		editID = -1;
		       $("#imgforrestricted").html("");
			$("#gcheck").remove();
			$('.showp').addClass('hide');
    			$('.showpm').removeClass('hide');
		});
		$("#btnRemoveCart").on('click', function(e){
			e.preventDefault();
		
			var dcid = $('#restrictedPricingProduct').attr('data-cart-item');
		
			$.ajax({
               		type: "POST",
                		url: "/cart/deleteitem",
                		data: { cartId: cartID, cartItemId: dcid},
                		headers: antiForgeryToken,
                 		success: function (data) {
                 			//not sure what to do if they remove from cart, I think take them to the cart page for now
                 			//window.location.href = cartUrl;
			    		restrictedPricingDialog.close();
			    		loadUserLinks();
				}
			});
		});
		$("#btnGoToCart").on('click', function(e){
			e.preventDefault();
			e.stopPropagation();
			AddToCart();	
		});
    	}
        //end restricted pricing

    //add to cart
    function AddToCart() {
	
	//because of design on mobile, make sure they haven't forgotten to select color / quantity
	if(isMobile){
	    if($('#colorSelected').val() === ''){
	        $(".pnlSelColors").first().before('<p class="textDkRed errorMsg padding10 borderDkRed textsemibold" role="alert">Please select one ' + localizedJS.Color + '</p>');
	        $('.imgBox').first().focus();
	        ScrollToElement('.PD_Step_1');
	        processing = false;
	        return false;
	    }
	    
	    if (GetQty() < lowestQty) {
	        $('.txtApparelQty').each(function () {
	            if ($(this).val() != '') {
	                $(this).css('background-color', '#ffd9d9').attr('aria-invalid', 'true');
	            }
	        });
	        $('.qtyErrorMsg').remove();
	        $('#chooseQuant').before('<p class="qtyErrorMsg textDkRed errorMsg padding10 margin15 borderDkRed textsemibold" role="alert">Minimum quantity for this item is ' + lowestQty + '.</p>');
	        $('input#txtQty').css('background-color', '#ffd9d9').attr('aria-invalid', 'true').focus();
	        ScrollToElement('#chooseQuant');
	        processing = false;
	        return false;
	    }
	}
	//get selected imprint locations
	GetSelectedImprintLocations();
	//get selected imprint colors
	GetSelectedImprintColors();
	$('.PD_Step_2').find('.errorMsg').remove();
	
	if (listImprintLocationIDs.length == 0) {
	    $('.imprint-location').first().before('<p class="textDkRed errorMsg padding10 borderDkRed marginBtm15 marginTop15 textsemibold" role="alert">Please select at least one imprint location and one imprint ' + localizedJS.Color + '</p>');
	    ScrollToElement('.PD_Step_2');
	   $('.imprint-location').find('input').first().focus();
	   processing = false;
	    return false;
	}
	
	if (listSelectedColors.length == 0 && totalImprintColors > 0) {
	    //$('.PD_Step_2').find('.errorMsg').remove();
	    $('.imprint-location').first().before('<p class="textDkRed errorMsg padding10 borderDkRed marginTop15 marginBtm15 textsemibold" role="alert">Please select at least one imprint ' + localizedJS.Color + '</p>');
	    ScrollToElement('.PD_Step_2');
	    $('.imprint-location').find('input').first().focus();
	    processing = false;
	    return false;
	}
	
	//get extra charges and update totals
	GetExtras();
	
	$('.extrasResult').hide();
	var adhesiveAttributeID = $('#adhSideOptions').find('input:checked').siblings('input').val();
	var nibColorAttributeID = $('#inkColorOptions').find('input:checked').siblings('input').val();
	var selectedOptionalExtras = $('#SelectedOptionalExtras').val();
	var selectedSizes = GetSelectedSizes();
	if (adhesiveAttributeID == "" || adhesiveAttributeID == undefined) {
	    adhesiveAttributeID = $('#adhesiveOptions').find('input:checked').siblings('input').val();
	}
	var baseTrimColor = selBaseTrim.val().split('/');
	var arrImprintLocationIDs = listImprintLocationIDs;
	var arrProductImprintLocationIDs = listProductImprintLocationIDs;
	var arrImprintColorsIDs = listSelectedColors;
	
	var priceEach = $("#lblPrice").html();
	var colorSelected = $("#colorSelected").val();
        
	var qty = GetQty();
	var lblTotal = $('#lblTotal').html();
	//$("#priceEachSummary").html(qty + "  @  " + priceEach + "  each  = <span class=\"textsemibold\">" +  lblTotal + "</span>");
	$('#qtySummary').html(qty);
	$('#colorSummary').html(colorSelected);

        //get selected imprint colors
        SetSummaryImprintColors();
        
        //get adhesive side selected
        $('.PD_adhSideOptions').remove();
        var adhesiveSide = $('#adhSideOptions').children('div').length;
        if (adhesiveSide > 0) {
            var adhesiveType = $('#adhSideOptions').find('label').val();
            var adhesiveSideSelected = $('#adhSideOptions').find('input:checked').val();
            $('#colorSummary').parent().after('<div class="clear tinySpace"></div><div class="PD_adhSideOptions c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Adhesive Side</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="adhesiveSideSummary">' + adhesiveSideSelected + '</p></div>');
        }

	//get adhesive type selected
	$('.PD_adhesiveOptions').remove();
	var adhesiveType = $('#adhesiveOptions').children('div').length;
	if (adhesiveType > 0) {
	    var adhesiveTypeSelected = $('#adhesiveOptions').find('label').html();
	    var adhesiveSideSelected = $('#adhesiveOptions').find('input:checked').val();
	    $('#colorSummary').parent().after('<div class="clear tinySpace"></div><div class="PD_adhesiveOptions c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Adhesive Type</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="adhesiveTypeSummary">' + adhesiveTypeSelected + ' : ' + adhesiveSideSelected + '</p></div>');
	}
        
	//get nib type selected
	$('.PD_NibTypeSummary').remove();
	var nibType = $('#nibOptions').children('div').length;
	if (nibType > 0) {
	    var nibTypeSelected = $('#nibOptions').find('input:checked').val();
	    $('#colorSummary').parent().after('<div class="clear tinySpace"></div><div class="PD_NibTypeSummary c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Tip Size</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="nibTypeSummary">' + nibTypeSelected + '</p></div>');
	}
	
	//get ink color selected
	$('.PD_inkColorSummary').remove();
	var inkColors = $('#inkColorOptions').children('div').length;
	if (inkColors > 0) {
	    var inkColorSelected = $('#inkColorOptions').find('input:checked').val();
	    $('#colorSummary').parent().after('<div class="clear tinySpace"></div><div class="PD_inkColorSummary c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Writing Ink ' + localizedJS.ColorCap + '</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="inkColorSummary">' + inkColorSelected + '</p></div>');
	}
	
	var OrderSummary = {
	    ProductID: prodID, Quantity: qty, ImprintColors: arrImprintColorsIDs, ImprintLocations: arrImprintLocationIDs, SelectedSizes: selectedSizes, BaseColorID: baseTrimColor[0], TrimColorID: baseTrimColor[1],
	    EditID: editID, ProductImprintLocations: arrProductImprintLocationIDs, NibColorAttributeID: nibColorAttributeID, AdhesiveAttributeID: adhesiveAttributeID, SelectedOptionalExtras: selectedOptionalExtras
	};

        $.ajax({
            url: "/productmvc/addtocart",
            type: "POST",
            datatype: 'json',
            contentType: "application/json",
            data: JSON.stringify(OrderSummary),
            beforeSend: function () {
                $('.cartLoadingImg').show();
                $('.cartError').html('');
            },
            success: function (result) {
                //$('.cartLoadingImg').toggle('slow');
                if (result.success == "true") {
                    OmniLogCartAdd(result.newCart == undefined ? true : result.newCart);
                    //Item Summary will be disabled for now.
                    /*$('.PD_Step_2').fadeOut('slow', function () {
                        $('.PD_Summary').fadeIn('100', function () {
                            $('.PD_Summary').removeClass('hide');
                            ScrollToElement('.PD_Summary', 500);
                        });
                    }); */
                    //This might be added back in the future. JWW 10/24
                    cartUrl = result.redirectUrl;
                    if($('#HideAdvertisedPrice').val() == 'True'){
                    		if (editID < 0){
                    			editID = result.cartItemID;
                    			
                    			DisplayRestricted(result.cartID, result.cartItemID);
                    		}else{
                    			window.location.href = result.redirectUrl;  
                    		}
                    		
            		}else{
            			window.location.href = result.redirectUrl;   
            		}
                                   
                } else {
                    $('.cartError').html('<div aria-live="polite">There was an error adding item to Cart. Please try again!</div>');
                }
            },
            error: function () {
            
                $('.cartError').html('<div aria-live="polite">There was an error adding item to Cart. Please try again!</div>');
            },
            done: function () {
            	   processing = false;
                $('.cartLoadingImg').hide();                 
            }
        });
    }
    //end add to cart

	//paging loading gif and overlay
	function loadingPage(){
		$('.loadingPage').removeClass('hide').show();
	}
	
	function hideLoading(){
		$('.loadingPage').addClass('hide').hide();
	}
	
	//customerimages
	function initCustomerImagesPages() {
            $('.imagespageselect').each(function () {
                 $('#' + this.id).off();
                $('#' + this.id).on("click keypress", function (e) {
                    if (e.type =='keypress' && !(e.which == 13)) { return;}
                    var vals = this.id.split('_');
                    var page = vals[1];
                    loadingPage();
                    $.ajax({
                        url: "/productmvc/customerimages/" + prodID + "/" + page,
                        type: "GET",
                        contentType: 'application/json',
                        dataType: 'html',
                        success: function (result) {
                            $('#customerImagesTSTab').html('');
                            $('#customerImagesTSTab').html(result);
                            hideLoading();
                            initCustomerImagesPages();
                            ScrollToElement("#detailTabs");
                        },
                        error: function () {
                            hideLoading();
                            //add error msg?
                        }
                    });
                });
            });
        }
	 //end customerimages

    //review/successstories functions
    function initSuccessPages() {
        $('.storiespageselect').each(function () {
            $('#' + this.id).off();
            $('#' + this.id).on("click keypress", function (e) {
                if (e.type =='keypress' && !(e.which == 13)) { return;}
                var vals = this.id.split('_');
                var page = vals[1];
                loadingPage();
                $.ajax({
                    url: "/productmvc/successstories/" + prodID + "/" + page,
                    type: "GET",
                    contentType: 'application/json',
                    dataType: 'html',
                    success: function (result) {
                        $('#successStoriesTSTab').html('');
                        $('#successStoriesTSTab').html(result);
                        hideLoading();
                        initSuccessPages();
                        ScrollToElement("#detailTabs");
                    },
                    error: function(){
                     	hideLoading();
                     	//add error msg?
                    }
                });
            });
        });
    }

    function initReviewPages() {
        $('.reviewspageselect').each(function () {
            $('#' + this.id).on("click keypress", function (e) {
                if (e.type =='keypress' && !(e.which == 13)) { return;}
                var vals = this.id.split('_');
                var page = vals[1];
                loadingPage();
                $.ajax({
                    url: "/productmvc/reviews/" + prodID + "/" + page + "/" + document.getElementById('reviewsPerPage').value + "/" + document.getElementById('reviewsOrderBy').value + "/" + document.getElementById('reviewsFilter').value,
                    type: "GET",
                    contentType: 'application/json',
                    complete: function(){
                    	$('.positiveReview').on('click');
			      $('.negativeReview').on('click');
                    },
                    dataType: 'html',
                    success: function (result) {
                        $('#reviewsTSTab').html('');
                        $('#reviewsTSTab').html(result);
                        hideLoading();
                        initReviewPages();
                        initReviewFilters();
                        ScrollToElement("#reviewFilters");
                    },
                    error: function(){
                       hideLoading();
                    }
                });
            });
        });
    }

    function initReviewFilters() {
        $('.reviewOptions').change(function () {
        	 loadingPage();
            $.ajax({
                url: "/productmvc/reviews/" + prodID + "/1/" + document.getElementById('reviewsPerPage').value + "/" + document.getElementById('reviewsOrderBy').value + "/" + document.getElementById('reviewsFilter').value,
                type: "GET",
                contentType: 'application/json',
                dataType: 'html',
                success: function (result) {
                    $('#reviewsTSTab').html('');
                    $('#reviewsTSTab').html(result);
                    hideLoading();
                    initReviewPages();
                    initReviewFilters();
                },
                error: function(){
                   hideLoading();
                }
            });
        });
        $('#readAllReviews').on("click keypress", function (e) {
            if (e.type =='keypress' && !(e.which == 13)) { return;}
        	 showReviewsLoading();
            $.ajax({
                url: "/productmvc/reviews/" + prodID + "/1",
                type: "GET",
                contentType: 'application/json',
                dataType: 'html',
                success: function (result) {
                    $('#reviewsTSTab').html('');
                    $('#reviewsTSTab').html(result);
                    hideReviewsLoading();
                    initReviewPages();
                    initReviewFilters();
                },
                error: function(){
                    	hideReviewsLoading();
                }
            });
        });

        $('.reviewFilter').each(function () {
            $('#' + this.id).on("click", function (e) {
                //if (e.type =='keypress' && !(e.which == 13)) { return;}
                var vals = this.id.split('_');
                var filter = '';
                if (vals.length > 1) {
                    filter = vals[1];
                }
                showReviewsLoading();
                $.ajax({
                    url: "/productmvc/reviews/" + prodID + "/1/" + document.getElementById('reviewsPerPage').value + "/" + document.getElementById('reviewsOrderBy').value + "/" + filter,
                    type: "GET",
                    contentType: 'application/json',
                    dataType: 'html',
                    success: function (result) {
                        $('#reviewsTSTab').html('');
                        $('#reviewsTSTab').html(result);
                        hideReviewsLoading();
                        initReviewPages();
                        initReviewFilters();
                        $('#reviewsOrderBy').focus();
                    },
                    error: function(){
                    	hideReviewsLoading();
                    }
                });
                return false;
            });
        });
    }
     function showReviewsLoading(){
		var container = $('#ReviewsContainer');
		$('#ReviewsLoadingImg').css({'height':container.height()});
		$('#ReviewsLoadingImg').show();
		$('#ReviewsLoadingImg').removeClass('hide');
    }
    
    function hideReviewsLoading(){
    		$('#ReviewsLoadingImg').hide();
		$('#ReviewsLoadingImg').addClass('hide');
    }
    //end review/successstories functions

    //more fitRating
    function initFitRatingPages() {
        $('.fitratingpageselect').each(function () {
            $('#' + this.id).on("click", function (e) {
                //if (e.type =='keypress' && !(e.which == 13)) { return;}
                //fitRatingFilter
                var vals = this.id.split('_');
                var page = vals[1];
                loadingPage();
                $.ajax({
                    url: "/productmvc/customerfitrating/" + prodID + "/" + page + "/" + document.getElementById('fitRatingFilter').value,
                    type: "GET",
                    contentType: 'application/json',
                    dataType: 'html',
                    success: function (result) {
                        $('#customerfitcomments').html('');
                        $('#customerfitcomments').html(result);
                        hideLoading();
                        initFitRatingPages();
                        ScrollToElement("#detailTabs");
                    },
                    error: function (){
                    	hideLoading();
                    	//add error msg?
                    }
                });
            });
        });
    }
    //end more fitRating


    //apparel glide
    function CalcPrice() {
        var TotalQty = 0;
        $('.txtApparelQty').each(function () {
            if ($(this).val() != '') {
                if (IsNumeric($(this).val())) {
                    TotalQty += parseInt($(this).val());
                }
            }
        });
        $('#txtQty').html(TotalQty);
        if (TotalQty >= lowestQty) {
            $('.qtyErrorMsg').remove();
             $('#txtQty').removeAttr('style');
            $('.CheckMarkQuantity').children('span').addClass('textGreen');
            if (selBaseTrim.val() != "") {
                $('.step1').removeClass('disabledBtn').addClass('bkgdBlue whiteLink');
            }
            var BreakNumBelow = -1;
            var BreakNumAbove = -1;
            for (var i = 0; i < arrBreak.length; i++) {
                if ((i + 1 >= arrBreak.length || arrBreak[i + 1] < 1) && TotalQty >= arrBreak[i] && arrBreak[i] > 0) {
                    BreakNumBelow = i;
                    BreakNumAbove = i;
                } else {
                    if (TotalQty >= arrBreak[i] && TotalQty < arrBreak[i + 1]) {
                        BreakNumBelow = i;
                        BreakNumAbove = i + 1;
                    }
                }
            }

            var newPrice = EstimatePrice(BreakNumBelow, TotalQty, 0);
            $('#lblPrice').html(currencySymbol + newPrice.toFixed(2).toString());
            $('#lblTotal').html(currencySymbol + (newPrice * TotalQty).toFixed(2).toString());
        } else {
            $('.CheckMarkQuantity').children('span').removeClass('textGreen');
            $('.step1').addClass('disabledBtn').removeClass('bkgdBlue whiteLink');
            $('#lblPrice').html('');
            $('#lblTotal').html('');
        }
    }

    function UnlockMoreColors(divNeedMoreColors, MaxImprintColors) {
        /// <summary>Called after clicking the more colors button, this displays the boxes after the first for additional color entries</summary>
        /// <param name="divNeedMoreColors">Div containing the more colors button</param>
        /// <param name="MaxImprintColors">Maximum number of imprint colors</param>
        //var MaxImprintColors = parseInt($('.imprintColorsCount').html());
        var colorsDisplayed = $(divNeedMoreColors).parent().siblings('.colorList').length;
        var colorsToAdd = MaxImprintColors - colorsDisplayed;
        $('#GFeedData').hide();
        $('.imprintButtonExtras').removeClass('hide');
        var newContent = "";
        for (var i = colorsDisplayed + 1; i <= MaxImprintColors; i++) {
            $(divNeedMoreColors).parent().siblings('.colorList').last().after(
            '<div class="colorList marginTop5"><label for="imprintColorAdd' + i +'" class="inlineMiddle paddingRight20">' + localizedJS.ColorCap + " " + i + '</label>' +
            '<input readonly id="imprintColorAdd' + i +'" class="imprintColorBox inlineMiddle selectedColor borderMdGray" title="Please select a ' + localizedJS.Color + ' from the ' + localizedJS.Color + ' picker" style="background-color: transparent;" />' +
            '<input class="imprintLocationID" type="hidden" value="" /><input class="imprintColorID" type="hidden" value="" /><input class="productImprintLocationID" type="hidden" value="" />' +
            '<a href="#" class="inlineMiddle imprintClearColor darkestLink noLine padding10 pointer" role="button" aria-label="Clear ' + localizedJS.Color + " " + i + '"><svg class="show" height="20px" width="20px"><title>Clear ' + localizedJS.Color + " " + i + '</title><use xlink:href="#svgIcon-remove"></use></svg></a></div>');
        }
        $(divNeedMoreColors).parent().hide();
        $('.PD_ImprintColorChip').first().find('.spnColorChip').focus();
    }

    //end apparel glide
    function getOrderTotal() {
        var priceEach = $("#lblPrice").html();
        var shipCost = 0;
        var setupCharge = 0;
        var quantity = GetQty();

        return (priceEach * quantity) + setupCharge + shipCost;
    }//glide

    function onSlideEnd(sender, e) {
        UpdatePrice(sender.get_element().value);
    }

    function SetQuantity() {
        if (checkQty() && StoreColor()) {
            resetCalcExtras();
            $('.selectedQty').html($('#' + quantityTextbox).val());
            $('#SelectedQtyPrice').html($("#" + priceLabel).html().replace(currencySymbol, ''));
            $('#SelectedQtyTotal').html($("#" + totalLabel).html().replace(currencySymbol, ''));
            $('.PD_SelectionPanel').slideDown();
            $('.PD_SelectionBox').removeClass('hide').fadeIn();
            $('.PD_QuantityChoicePanel').fadeOut('normal', function () {
                $('.PD_ImprintChoicePanel').fadeIn();
            });
            LoadOptionalExtras();
        }
    }
    
    function updateGlideAria(){
    	 $(".jslider-pointer").attr("aria-valuenow", $('#txtQty').val().toString());	
    }

    function SetupGlide() {
        if (Glide4imprint) {
            glide = new Glide4imprint();
            glide.Init(arrBreak, arrPrice, steppingQty); 
            if ($.slider) {
                $("#GlideSlider").sliderglide({
                    from: glide.MinPoint(),
                    to: glide.MaxPoint(),
                    step: 1,
                    smooth: true,
                    scale: [glide.MinBreakQty(), glide.MaxBreakQty()],
                    limits: false,
                    dimension: '', // Needed for the hint bubble above slider
                    valueOffset: 18, // Custom added property, offsets the value bubble to the right (value is in px)
                    calculate: function (value) {
                        UpdatePrice(value.toString());
                        updateGlideAria();
                        //return quantityTextbox;
                        return $('#txtQty').val(); // Need to return the quantity for the hint bubble to display it
                    }
                });

                // The end values on the slider ui need to be updated manually
                var endpointLbls = $('div.jslider-scale span ins');
                
                endpointLbls.eq(0).html(glide.MinBreakQty());
                endpointLbls.eq(1).html(glide.MaxBreakQty());
		   
		   if (!isApparelItem) {
			    $(".jslider-pointer").attr({
			   	"tabindex": "0",
			   	"role": "slider",
			   	"aria-valuemin": glide.MinBreakQty().toString(),
			   	"aria-valuemax": glide.MaxBreakQty().toString(),
			   	"aria-valuenow": $('#txtQty').val().toString()
			   });
		   }
                // If editing update the slider with the appropriate qty
                if (editQty > 0) {
                   if (!isApparelItem) {
                        TextUpdateSliderFinish(editQty, false);
                    } else {
                        CalcPrice();
                    }
                }
            }
        }
    }

    function SetSlider(qty) {
        var prevValue = $("#GlideSlider").sliderglide("value");
        $("#GlideSlider").sliderglide("value", glide.SetSlideQty(qty));
    }

    function TextUpdateSlider(qty, focus) {
        if (txtTimer != null) {
            clearTimeout(txtTimer);
        }
        var updateTime = 750;
        if(qty > lowestQty) updateTime = 750;
        //txtTimer = setTimeout("TextUpdateSliderFinish('" + qty + "')", 500);
        //txtTimer = setTimeout("TextUpdateSliderFinish('" + qty + "')", 500);
        //if( !!window.MSInputMethodContext && !!document.documentMode){
        	//sigh......
        //	txtTimer = setTimeout(function(){TextUpdateSliderFinish(qty);}, 1600);
        //}else{
       	 txtTimer = setTimeout(function(){TextUpdateSliderFinish(qty, focus);}, updateTime);
        //}
        //txtTimer = setTimeout(TextUpdateSliderFinish(qty), 500);
    }

    function CheckForSingleQtyBreak() {
        // The glide slider will be disabled if there is only one break, so need to fill the price each in with the one price
        if (arrBreak[2] <= 0) {
            var price = arrPrice[1];
            var qty = arrBreak[1];
            $('#txtQty').val(qty);
            $('#lblPrice').html(currencySymbol + price.toFixed(2).toString());
            $('#lblTotal').html(currencySymbol + (price * qty).toFixed(2).toString());
            $('.layout-slider').addClass('hide');
        }
    }

    function UpdatePrice(qty) {
        var firstDigit = glide.GetBreakSegment(qty);
        var quantity = glide.GetSlideQty(firstDigit, qty);
        if (glide.MinBreakQty() <= quantity) {
            if (firstDigit != null) {
                var newPrice = glide.GetPriceEstimate(firstDigit, quantity, qty);
                var startPrice = arrPrice[1]; // pricing always starts at index 1
                $('#lblPrice').html(currencySymbol + newPrice.toFixed(2).toString());
                $('#lblTotal').html(currencySymbol + (newPrice * quantity).toFixed(2).toString());
                $('#lblTotalMobi').html(currencySymbol + (newPrice * quantity).toFixed(2).toString());
                $('#txtQty').val(quantity);
		     $('#txtQty').removeAttr('style');
                // Not used on intro page
                if (newPrice.toFixed(2) >= startPrice.toFixed(2)) {
                    if ($('div#YouSaveBox').css('visibility') == 'visible') { $('div#YouSaveBox').css('visibility', 'hidden'); }
                    //if ($('div#YouSaveBoxMobi').css('visibility') == 'visible') { $('div#YouSaveBoxMobi').css('visibility', 'hidden'); }
                } else {
                    if ($('div#YouSaveBox').css('visibility') == 'hidden') { $('div#YouSaveBox').css('visibility', 'visible'); }
                    $('#divYouSave').html(currencySymbol + ((startPrice * quantity) - (newPrice * quantity)).toFixed(2).toString());
                    //if ($('div#YouSaveBoxMobi').css('visibility') == 'hidden') { $('div#YouSaveBoxMobi').css('visibility', 'visible'); }
                    //$('span#divYouSaveMobi').html(currencySymbol + ((startPrice * quantity) - (newPrice * quantity)).toFixed(2).toString());
                }
            }
        }
    }

    TextUpdateSliderFinish = function(qty, focus) {
    	  $('.qtyErrorMsg').remove();
        if (glide.IsNumeric(qty)) {
        	$('.step1').removeClass('disabledBtn').addClass('bkgdBlue whiteLink');	
        	$('#txtQty').removeAttr('style').removeAttr('aria-invalid'); 
            qty = parseInt(qty);

            var SlideQty = qty;
            if (lowestQty > qty) { qty = lowestQty; } //enforce min quantity
            if (lowestQty <= qty) {
                for (var i = glide.BreakArray().length - 1; i > 0; i--) {
                    if (glide.BreakArray()[i] > 0) {
                        // If the qty is greater than the end of the slider, need to set the value to slide to to the last break.
                        if (qty > glide.BreakArray()[i]) {
                            SlideQty = glide.BreakArray()[i];
                            qty = glide.EnforceSteppingQty(qty, steppingQty);
                        }
                        break;
                    }
                }

                // Only update the slider if there are multiple qty breaks
                if (arrBreak[2] > 0) {
                    SetSlider(SlideQty);
                }

                // The slider doesn't deal in qtys, just percentages, so sometimes it will adjust the qty when it does
                // its percentage calculation if the user typed a qty. This will reset it to the user entered value.
                var qtyTxtbox = $('#txtQty');
                if (qty > SlideQty) {
                    qtyTxtbox.val(qty);

                    var price = $('#lblPrice').html().trim().substring(1);    // Trims the currency symbol
                    $('#lblTotal').html(currencySymbol + (price * qty).toFixed(2).toString());
                    $('.jslider-value span').first().html(qty);
                } else {
                    if (parseInt(qtyTxtbox.val()) != qty) {
                        if (glide.EnforceSteppingQty(qty, steppingQty) == qty) {
                            qtyTxtbox.val(qty);
                            var price = $('#lblPrice').html().trim().substring(1);
                            $('#lblTotal').html(currencySymbol + (price * qty).toFixed(2).toString());
                            $('.jslider-value span').first().html(qty);
                        }
                    }
                }
                if(focus) {
                	qtyTxtbox.select(); 
        	}
                
            }
        } else {
        	$('chooseQuant').before('<p class="textDkRed qtyErrorMsg borderDkRed padding10 textsemibold margin15" role="alert">Please enter a valid quantity. Minimum quantity for this item is ' + lowestQty + '</p>');
        	$('.step1').removeClass('bkgdBlue whiteLink').addClass('disabledBtn');	
        	$('input#txtQty').css('background-color', '#ffd9d9').attr('aria-invalid', 'true').focus();
        	return false;
        }
        
    };

    function IsNumeric(strString) {
        var strValidChars = "0123456789";
        var strChar;
        var blnResult = true;


        for (i = 0; i < strString.length && blnResult == true; i++) {
            strChar = strString.charAt(i);
            if (strValidChars.indexOf(strChar) == -1) {
                blnResult = false;
            }
        }
        return blnResult;
    }

    function SelectQty(columnId) {
        /// <summary>Changes the quantity to the value of the price break that the user clicked on</summary>
        /// <param name="columnId">Column index in the price break table</param>
        if (arrBreak[columnId] > 0) {
            $('#txtQty').val(arrBreak[columnId]);
            SetSlider(arrBreak[columnId]);
        }
    }
    //end glide

    function showPos(event) {
        var Flyout;
        Flyout = document.getElementById('PD_360Flyout');
        Flyout.style.display = "block";
    }

    function ShowImprintColors(triggerDiv) {
        //$(triggerDiv).parent().parent().siblings(".imprint-colors-content").toggle("slow");
        if ($(triggerDiv).parent().siblings('.chkbxImprintLocation').prop('checked') == true) {
            $(triggerDiv).parent().siblings('.chkbxImprintLocation').prop('checked', false);
            $(triggerDiv).parent().siblings(".imprint-colors-content").fadeOut("slow");
        } else {
            $(triggerDiv).parent().siblings('.chkbxImprintLocation').prop('checked', true);
            $(triggerDiv).parent().siblings(".imprint-colors-content").fadeIn("slow");
        }
    }

    //Load adhesive options
    function LoadAdhesiveOptions() {
        var baseTrim = selBaseTrim.val();
        if (baseTrim != undefined && baseTrim != "") {
            $.ajax({
                type: "POST",
                url: "/productattribute/adhesive",
                data: { 'ProductID': prodID, 'Color': baseTrim },
                dataType: "html",
                timeout: 15000,
                success: function (data) {
                    adhSidesOptions = data;
                    var parsedData = JSON.parse(data);
                    if (parsedData != null && parsedData.adhesive.length > 0) {
                        adhSidesOptions = parsedData; // Set to the global object for use when the user is making selections

                        var AdhesiveOptions = new Array();
                        var AdhSideOptions = new Array();
                        var AdhesiveOptionIDs = new Array();
                        var AdhesiveSideIDs = new Array();

                        var EditAdhesiveValue = '';
                        var EditAdhSideValue = '';

                        for (var i = 0; i < parsedData.adhesive.length; i++) {
                            var optionFound = false;

                            // Look to see if the option has already been added to the adhesive option array
                            for (var j = 0; j < AdhesiveOptions.length; j++) {
                                if (!optionFound && AdhesiveOptions[j] == parsedData.adhesive[i].adh) {
                                    optionFound = true;
                                }
                            }

                            // if the adhesive option was not found, add the option to the array for display
                            if (!optionFound) {
                                AdhesiveOptions[AdhesiveOptions.length] = parsedData.adhesive[i].adh;
                                AdhesiveOptionIDs[AdhesiveOptionIDs.length] = parsedData.adhesive[i].id;
                            } else {
                                optionFound = false;    // Reset the variable for the color check
                            }

                            // Look to see if the option has already been added to the side option array
                            for (var j = 0; j < AdhSideOptions.length; j++) {
                                if (!optionFound && AdhSideOptions[j] == parsedData.adhesive[i].side) {
                                    optionFound = true;
                                }
                            }

                            // if the side option was not found, add the option to the array for display
                            if (!optionFound) {
                                AdhSideOptions[AdhSideOptions.length] = parsedData.adhesive[i].side;
                                AdhesiveSideIDs[AdhesiveSideIDs.length] = parsedData.adhesive[i].id;
                            }

                            if (editID > 0) {
                                if (parsedData.adhesive[i].id == adhesiveInput.val()) {
                                    EditAdhSideValue = parsedData.adhesive[i].side;
                                    EditAdhesiveValue = parsedData.adhesive[i].adh;
                                }
                            }
                        }

                        // All adhesive and side options have been located, now display them if there's more than 1
                        if (AdhesiveOptions.length > 1) {
                            AdhesiveOptions.sort();
                            $('#adhesiveOptions input').off('click', adhesiveOptionChanged); // Unbind the handler from any previous radio buttons
                            $('#adhesiveOptions').html(''); // Remove any previously displayed radio buttons
                            var checked = false;
                            for (var i = 0; i < AdhesiveOptions.length; i++) {
                                var inputId = "adhesive" + i;
                                var radioBtn = '<div class="floatLeft marginRight10  marginTop5 clear"><input type="radio" id="' + inputId + '" name="adhesive" tabindex="0" value="' + AdhSideOptions[i] + '"';

                                // Set up the selected option, the first option by default if the item is not being edited
                                if ((editID > 0 && AdhesiveOptions[i] == EditAdhesiveValue) || (editID <= 0 && i == 0)) {
                                    radioBtn += ' checked';
                                    checked = true;
                                }

                                radioBtn += ' />';

                                radioBtn += '<label for="' + inputId + '" name="' + AdhSideOptions[i] + '">' + AdhesiveOptions[i] + '</label><input type="hidden" value="' + AdhesiveOptionIDs[i] + '" /></div>';

                                $('#adhesiveOptions').append(radioBtn);
                                
                            }
                            if(!checked){
                            	$('#adhesive0').attr('checked', true);
                            }
                            $('.PD_Adhesive').show();
                            $('#adhesiveOptions input').on('click', adhesiveOptionChanged); // Bind the handler to the new radio buttons
                        } else {
                            $('.PD_Adhesive').hide();
                        }

                        if (AdhSideOptions.length > 1) {
                            AdhSideOptions.sort();
                            $('#adhSideOptions input').off('click', adhesiveOptionChanged); // Unbind the handler from any previous radio buttons
                            $('#adhSideOptions').html(''); // Remove any previously displayed options
                            var checked = false;
                            for (var i = 0; i < AdhSideOptions.length; i++) {
                                var adhesiveSide = "adhesiveSide" + i;
                                var radioBtn = '<div class="floatLeft marginRight10 marginTop5 clear"><input type="radio" id="' + adhesiveSide + '" name="ink" tabindex="0" value="' + AdhSideOptions[i] + '"';

                                // Set up the selected option, the first option by default if the item is not being edited
                                if ((editID > 0 && AdhSideOptions[i] == EditAdhSideValue) || (editID <= 0 && i == 0)) {
                                    radioBtn += ' checked';
                                    checked = true;
                                }

                                radioBtn += ' />';

                                radioBtn += '<label for="' + adhesiveSide + '" name="' + AdhSideOptions[i] + '">' + AdhSideOptions[i] + '</label><input type="hidden" value="' + AdhesiveSideIDs[i] + '" /></div>';

                                $('#adhSideOptions').append(radioBtn);
                            }
                            if(!checked){
                            	$('#adhesiveSide0').attr('checked', true);
                            }
                            $('.PD_AdhesiveSide').show();
                            $('#adhSideOptions input').on('click', adhesiveOptionChanged); // Bind the handler to the new radio buttons

                        } else {
                            $('.PD_AdhesiveSide').hide();
                        }

                        if (adhSidesOptions.adhesive.length > 0 && (AdhesiveOptions.length > 1 || AdhSideOptions.length > 1)) {
                            // If there is a nib or color selection to be made, set the default selections into the hidden input
                            // Edit mode implications?
                            //$('#' + adhesiveInput).val(adhSidesOptions.adhesive[0].id);
                            adhesiveOptionChanged();
                            // Do the initial pass on the ink colors to make sure only the available ones are displayed
                            toggleAvailableAdhesiveSides();
                        }
                    } else {
                        $('.PD_Adhesive').hide();
                        $('.PD_AdhesiveSide').hide();
                    }
                },
                error: function () {
                    $('.PD_Adhesive').hide();
                    $('.PD_AdhesiveSide').hide();
                }
            });
        }
    }

    function adhesiveOptionChanged() {
        toggleAvailableAdhesiveSides();

        // Find the selected nib and ink color in the master list and set the id to the hidden input
        var selectedAdhesive = $('#adhesiveOptions input:checked').val();
        var selectedAdhSide = $('#adhSideOptions input:checked').val();

        for (var i = 0; i < adhSidesOptions.adhesive.length; i++) {
            if ((selectedAdhSide == adhSidesOptions.adhesive[i].side && selectedAdhesive == adhSidesOptions.adhesive[i].adh) ||
                (typeof selectedAdhSide == 'undefined' && selectedAdhesive == adhSidesOptions.adhesive[i].adh) ||
                (selectedAdhSide == adhSidesOptions.adhesive[i].side && typeof selectedAdhesive == 'undefined')) {
                $('#adhSideOptions').find('input:checked').siblings('input').val(adhSidesOptions.adhesive[i].id);
                return;
            }
        }
    }

    function toggleAvailableAdhesiveSides() {
        // Need to hide ink colors that are not available for the selected nib size
        var selectedAdh = $('#adhesiveOptions input:checked').val();

        // Don't bother unless there are nib options and there are ink options set
        if (typeof selectedAdh != 'undefined' && adhSidesOptions.adhesive.length > 0) {
            var adhSideOptions = $('#adhSideOptions span');
            if (adhSideOptions.length > 0) {
                var selectedAdhesiveSides = new Array();

                // Populate the array with all of the possible ink colors for this nib
                for (var i = 0; i < adhSidesOptions.adhesive.length; i++) {
                    if (selectedAdh == adhSidesOptions.adhesive[i].adh) {
                        selectedAdhesiveSides[selectedAdhesiveSides.length] = adhSidesOptions.adhesive[i];
                    }
                }

                // Toggle the side options
                for (var i = 0; i < selectedAdhesiveSides.length; i++) {
                    var sideFound = false;

                    for (var j = 0; j < adhSideOptions.length; j++) {
                        if (!sideFound && $(selectedAdhesiveSides[i]).attr('name') == adhSideOptions[j].adh) { colorFound = true; }
                    }

                    if (colorFound) {
                        $(adhSideOptions[i]).show();
                    } else {
                        $(adhSideOptions[i]).hide();

                        // If the option being hidden is checked, move the option to the first visible ink option
                        if ($(adhSideOptions[i]).children('input').is(':checked')) $('#adhSideOptions span:visible input').eq(0).attr('checked', 'checked');
                    }
                }
            }
        }
    }
    //end adhesive section

    //load nib and ink color
    function LoadNibInkColor() {
        var selectedColorID = selBaseTrim.val();
        if (selectedColorID != undefined && selectedColorID != "") {
            $.ajax({
                type: "POST",
                url: "/productattribute/nibink",
                data: { 'ProductID': prodID, 'Color': selectedColorID, 'EditID': editID },
                dataType: "html",
                timeout: 15000,
                success: function (data) {
                    nibInkOptions = data;
                    var parsedData = JSON.parse(data);
                    if (parsedData != null && parsedData.inknib.length > 0) {
                        nibInkOptions = parsedData; // Set to the global object for use when the user is making selections

                        var NibOptions = new Array();
                        var ColorOptions = new Array();
                        var ProductColorAttributeIDs = new Array();

                        var EditNibValue = '';
                        var EditInkColorValue = '';

                        for (var i = 0; i < parsedData.inknib.length; i++) {
                            var optionFound = false;

                            // Look to see if the option has already been added to the nib option array
                            for (var j = 0; j < NibOptions.length; j++) {
                                if (!optionFound && NibOptions[j] == parsedData.inknib[i].nib) {
                                    optionFound = true;
                                }
                            }

                            // if the nib option was not found, add the option to the array for display
                            if (!optionFound) {
                                NibOptions[NibOptions.length] = parsedData.inknib[i].nib;
                            } else {
                                optionFound = false;    // Reset the variable for the color check
                            }

                            // Look to see if the option has already been added to the color option array
                            for (var j = 0; j < ColorOptions.length; j++) {
                                if (!optionFound && ColorOptions[j] == parsedData.inknib[i].ink) {
                                    optionFound = true;
                                }
                            }

                            // if the nib option was not found, add the option to the array for display
                            if (!optionFound) {
                                ColorOptions[ColorOptions.length] = parsedData.inknib[i].ink;
                                ProductColorAttributeIDs[ProductColorAttributeIDs.length] = parsedData.inknib[i].id;
                            }

                            if (editID > 0) {
                                if (parsedData.inknib[i].id == nibInkInput.val()) {
                                    EditInkColorValue = parsedData.inknib[i].ink;
                                    EditNibValue = parsedData.inknib[i].nib;
                                }
                            }
                        }

                        // All color and nib options have been located, now display them if there's more than 1
                        if (NibOptions.length > 0) {
                            //NibOptions.sort();
                            $('#nibOptions input').off('click', NibInkOptionChanged); // Unbind the handler from any previous radio buttons
                            $('#nibOptions').html(''); // Remove any previously displayed radio buttons
                            var checked = false;
                            for (var i = 0; i < NibOptions.length; i++) {
                                var inputId = "nib" + i;
                                var radioBtn = '<div class="floatLeft marginRight10 marginTop5 clear"><input type="radio" id="' + inputId + '" name="nib" tabindex="0" value="' + NibOptions[i] + '"';

                                // Set up the selected option, the first option by default if the item is not being edited
                                if ((editID > 0 && NibOptions[i] == EditNibValue) || (editID <= 0 && i == 0)) {
                                    radioBtn += ' checked';
                                    checked = true;
                                }

                                radioBtn += ' />';

                                radioBtn += '<label for="' + inputId + '" name="' + ColorOptions[i] + '">' + NibOptions[i] + '</label></div>';

                                $('#nibOptions').prepend(radioBtn);
                            }
                            if(!checked){
                            	$('#nib0').attr('checked', true);
                            }
                            $('.PD_NibSize').show();
                            $('#nibOptions input').on('click', NibInkOptionChanged); // Bind the handler to the new radio buttons
                        } else {
                            $('.PD_NibSize').hide();
                        }

                        if (ColorOptions.length > 0) {
                            //ColorOptions.sort();
                            //ProductColorAttributeIDs.sort();
                            $('#inkColorOptions input').off('click', NibInkOptionChanged); // Unbind the handler from any previous radio buttons
                            $('#inkColorOptions').html(''); // Remove any previously displayed options
                            var checked = false;
                            for (var i = 0; i < ColorOptions.length; i++) {
                                var inkId = "ink" + i;
                                var radioBtn = '<div class="floatLeft marginRight10  marginTop5 clear"><input type="radio" id="' + inkId + '" name="ink" tabindex="0" value="' + ColorOptions[i] + '"';

                                // Set up the selected option, the first option by default if the item is not being edited
                                if ((editID > 0 && ColorOptions[i] == EditInkColorValue) || (editID <= 0 && i == 0)) {
                                    radioBtn += ' checked';
                                    checked = true;
                                }

                                radioBtn += ' />';

                                //radioBtn += '<label for="' + inkId + '" name="' + ColorOptions[i] + '">' + ColorOptions[i] + '</label><input type="hidden" tabindex="0" value="' + ProductColorAttributeIDs[i] + '" /></div>';
                                //Allows the hidden input to be assigned a class so the value can be updated via javascript
                                var colorName = "colorName" + ColorOptions[i];
                                radioBtn += '<label for="' + inkId + '" name="' + ColorOptions[i] + '">' + ColorOptions[i] + '</label><input class="' + colorName + '"type="hidden" tabindex="0" value="' + ProductColorAttributeIDs[i] + '" /></div>';

                                $('#inkColorOptions').append(radioBtn);
                            }
                            if(!checked){
                            	$('#ink0').attr('checked', true);
                            }
                            $('.PD_InkColor').show();
                            $('#inkColorOptions input').on('click', NibInkOptionChanged); // Bind the handler to the new radio buttons

                            if (NibOptions.length < 2) {
                                // The nib section is not shown, but the ink color section is, so the step number needs to be changed. Take the number from nib section.
                                $('.PD_InkColor .PD_ChoiceHeading_Num').html($('.PD_NibSize .PD_ChoiceHeading_Num').html());
                            }
                        } else {
                            $('.PD_InkColor').hide();
                        }

                        if (nibInkOptions.inknib.length > 0 && (NibOptions.length > 1 || ColorOptions.length > 1)) {
                            // If there is a nib or color selection to be made, set the default selections into the hidden input
                            // Edit mode implications?
                            NibInkOptionChanged();

                            // Do the initial pass on the ink colors to make sure only the available ones are displayed
                            toggleAvailableInkColors();
                        }
                    } else {
                        $('.PD_NibSize').hide();
                        $('.PD_InkColor').hide();
                    }
                },
                error: function () {
                    $('.PD_NibSize').hide();
                    $('.PD_InkColor').hide();
                }
            });
        }
    }

    function NibInkOptionChanged() {
        toggleAvailableInkColors();

        // Find the selected nib and ink color in the master list and set the id to the hidden input
        var selectedInk = $('#inkColorOptions input:checked').val();
        var selectedNib = $('#nibOptions input:checked').val();

        for (var i = 0; i < nibInkOptions.inknib.length; i++) {
            if ((selectedInk == nibInkOptions.inknib[i].ink && selectedNib == nibInkOptions.inknib[i].nib) ||
                (typeof selectedInk == 'undefined' && selectedNib == nibInkOptions.inknib[i].nib) ||
                (selectedInk == nibInkOptions.inknib[i].ink && typeof selectedNib == 'undefined')) 
            {
                //console.log("pre change check");
                nibInkInput.val(nibInkOptions.inknib[i].id);
                //Update the hidden input that holds the value to properly match the nib type selected.
                $('.colorName' + nibInkOptions.inknib[i].ink).val(nibInkOptions.inknib[i].id);
                return;
            }
        }
    }

    function toggleAvailableInkColors() {
        // Need to hide ink colors that are not available for the selected nib size
        var selectedNib = $('#nibOptions input:checked').val();

        // Don't bother unless there are nib options and there are ink options set
        if (typeof selectedNib != 'undefined' && nibInkOptions.inknib.length > 0) {
            var inkOptions = $('#inkColorOptions div');
            if (inkOptions.length > 0) {
                var nibInkColors = new Array();

                // Populate the array with all of the possible ink colors for this nib
                for (var i = 0; i < nibInkOptions.inknib.length; i++) {
                    if (selectedNib == nibInkOptions.inknib[i].nib) {
                        nibInkColors[nibInkColors.length] = nibInkOptions.inknib[i];
                    }
                }

                // Toggle the ink colors
                for (var i = 0; i < inkOptions.length; i++) {
                    var colorFound = false;

                    for (var j = 0; j < nibInkColors.length; j++) {
                        if (!colorFound && $(inkOptions[i]).children('label').first().attr('name') == nibInkColors[j].ink) { colorFound = true; }
                    }

                    if (colorFound) {
                        $(inkOptions[i]).show();
                    } else {
                        $(inkOptions[i]).hide();

                        // If the option being hidden is checked, move the option to the first visible ink option
                        if ($(inkOptions[i]).children('input').is(':checked')) $('#inkColorOptions div:visible input').eq(0).attr('checked', 'checked');
                    }
                }
            }
        }
    }//end nib and ink color events


    //Delete selected imprint color
    function DeleteImprintColor(triggerElement) {
        ///<summary>Called after clicking delete all colors button, removes any additional imprint color</summary>
        ///<param name="triggerElement">The imprint location in focus</param>
        $(triggerElement).siblings('.selectedColor').css("backgroundColor", "rgba(0, 0, 0, 0)");
        $(triggerElement).siblings('.selectedColor').prop('title', 'Please select a "' + localizedJS.Color + '" from the "' + localizedJS.Color + '" picker');
        ResetImprintCharges();
        ValidateCustomizeSections();

    }

    function ClearImprintColors(triggerElement) {
        ///<summary>Called after clicking delete all colors button, removes any additional imprint color</summary>
        ///<param name="triggerElement">The imprint location in focus</param>
        $(triggerElement).parent().siblings('.colorList').not('.colorList:first').remove();
        $(triggerElement).parent().siblings('.colorList').first().find('.selectedColor').removeAttr('style');
        $(triggerElement).parent().siblings('.colorList').first().find('.selectedColor').prop('title', 'Please select a "' + localizedJS.Color + '" from the "' + localizedJS.Color + '" picker');
        ResetImprintCharges();
        ValidateCustomizeSections();
        $('.addColors').show();
        $('.moreImprintColors').show();
        $('.PD_ImprintColorChip').first().find('.spnColorChip').focus();
    }

    function CheckImprints() {
        var count = 0;
        $('.chkbxImprintLocation').each(function () {
            if ($(this).is(':checked')) {
                count++;
            }
        });

        if (count > 0) { return true; }

        return false;
    }

    function CheckImprintColors() {
        $('.chkbxImprintLocation').each(function () {
            var count = 0;
            if ($(this).is(':checked')) {
                count = 0;
                var imprintLocationID = $(this).siblings('.imprintLocationID').val();
                $('.' + imprintLocationID).children('.colorList').each(function () {

                    if ($(this).children('.selectedColor').css('backgroundColor') != "rgba(0, 0, 0, 0)") {
                        count += 1;
                    }
                });
            }
            if (count == 0) {
                $(this).attr('checked', false);
            }
        });

        $(".imprint-colors-content").fadeOut("slow", function () { });
        return CheckImprints();
    }

    function GetSelectedImprintColors() {
        listSelectedColors = [];
        listSelectedColorsRGB = [];
        listSelectedImprintLocationName = [];
        var colorIDs = [];
        var colorRGBs = [];
        $('.chkbxImprintLocation').each(function () {
            if ($(this).prop('checked')) {
                var colorsList = $(this).parent().siblings('.imprint-colors-content').find('.colorList');
                colorIDs = [];
                colorRGBs = [];
                $(colorsList).each(function () {
                    var backgroundColor = $(this).find('.selectedColor').css('backgroundColor');
                    if (backgroundColor != "rgba(0, 0, 0, 0)" && backgroundColor != 'transparent') {
                        colorIDs.push($(this).find('.imprintColorID').val());
                        colorRGBs.push(backgroundColor);
                    }
                });
                if (colorIDs.length > 0) {
                    listSelectedColors.push(colorIDs);
                }
                if (colorRGBs.length > 0) {
                    listSelectedColorsRGB.push(colorRGBs);
                    listSelectedImprintLocationName.push($(this).siblings('.imprintLocationName').val());
                }
            }
        });
    }


    //sample request
    function SampleRequest() {
        $('.sampleError').remove();
        $('.sampleCancel').remove();
        
        var data = { catalogAlias: catAlias };
        $.ajax({
            url: "/productmvc/samplerequest",
            type: "POST",
            data: JSON.stringify(data),
            beforeSend: function (req) {
                $('#imgSampleReq1Loading').fadeIn('fast');
            },
            complete: function (req) {
                $('#imgSampleReq1Loading').fadeOut('fast');
                $('.sampleBtnContainer').hide();
            },
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                //If the user is able to place a sample request display the sample request form otherwise let them know when they are not able to.
                if (result.Status == 'success') {
                    $('#samplePanel').hide();
                    $('#samplePanel').html(result.HtmlString).slideDown("slow", function () { });
                    $('input').removeClass('input-validation-error');
                    $('select').removeClass('input-validation-error');
                    ScrollToElement('#SampleRequestForm');
                    $('#FirstName').focus();
                    $('#btnSubmitSampleReq').on("click keypress", function (e) { if (e.type =='keypress' && !(e.which == 13)) { return;} SubmitSampleRequest(); });
                }else {
                    $('.sampleRequestPanel').after(result.HtmlString);
                }
            }
        });
    }

    function SubmitSampleRequest() {
    
    
        var formValid = true;
        $('.ErrorMsgPanel').remove();
        $('.infoText').first().after('<div class="ErrorMsgPanel text15 validation-summary-errors textDkRed hide" id="ErrorBox" role="alert"><p class="paddingTop15 textBold marginLeft10 validationHeading textDkRed" id="ErrorTitle">Oops! Some of the information you entered is not correct.</p><div class="padding10 textDkRed" id="ErrorMsgBox"><ul class="text14"></ul></div></div>');
        $('.txtReq').each(function () {
            var valid = true;
            if (this.value.trim() == ""  || (this.pattern != "" && this.value.search(this.pattern) < 0)) {
                formValid = false;
                valid = false;
            }
            if (!valid) {
                $(this).css("background-color", "#ffd9d9");
                $(this).attr("aria-invalid", "true");
                $('#ErrorMsgBox > ul').append('<li><a href="#' + this.id + '" tabindex="0" role="link">Please Enter ' + this.title + '</a></li>');
            } else {
                $(this).css("background-color", "white");
                $(this).attr({
                		"aria-invalid": "false",
                		"tabindex": "-1"
                	});
            }
        });

        if (!formValid) {
            $('#ErrorBox').removeClass("hide");
            $('#btnSubmitSampleReq').blur();
	  	 $('#ErrorMsgBox > ul > li:first-child').find('a').focus();
            return formValid;
        }

        var sampleRequestFormData = {
             CatalogAlias: catAlias, FirstName: $('#FirstName').val(), LastName: $('#LastName').val(), CompanyName: $('#CompanyName').val(), Address1: $('#Address1').val(), Address2: $('#Address2').val(), City: $('#City').val(), State: $('#State').val(),
            ZipCode: $('#ZipCode').val(), PhoneNumber: $('#PhoneNumber').val(), PhoneExt: $('#PhoneExt').val(), Comments: $('#Comments').val(), Email: $('#Email').val(), ProductName: $('#ProductName').val()
        };
        if(! $('#SampleRequestForm').hasClass('submittingForm') ){
        	$('#SampleRequestForm').addClass('submittingForm');
	        $.ajax({
	            url: "/productmvc/submitsamplerequest",
	            type: "POST",
	            data: JSON.stringify(sampleRequestFormData),
	            contentType: 'application/json',
	            dataType: 'json',
	            beforeSend: function() {
	                $('#btnSubmitSampleReq').prop('disabled', true);
	            },
	            success: function (result) {
	                if (result.success == "true" || result.success == "banned") {
	                    $('.sampleRequestPanel').after('<p class="sampleSuccess clear textsemibold marginTop10 textBlue" aria-live="polite"><svg height="16px" width="16px" aria-hidden="true"><use xlink:href="#svgIcon-checkMarkBox"></use></svg> Sample request submitted.</p>');
	                }
	                else if (result.success == "maxLimit") {
	                	$('.sampleRequestPanel').after('<p class="sampleError clear textsemibold marginTop10 textRed" aria-live="polite">You have requested quite a few samples recently! For a sample of this item, or any additional samples, please contact a friendly customer service representative using the phone number at the top of the page.</p>');
	                }
	                else {
	                    $('.sampleRequestPanel').after('<p class="sampleError clear textsemibold marginTop10 textRed" aria-live="polite">There was an issue with your request.</p>');
	                }
	                CancelSampleRequest();
	                $('#FirstName').blur();
	                $('#SampleRequestForm').removeClass('submittingForm');
	            },
	            error: function(){
	            		$('.sampleRequestPanel').after('<p class="sampleError clear textsemibold marginTop10 textRed" aria-live="polite">There was an issue with your request.</p>');
	            		$('#SampleRequestForm').removeClass('submittingForm');
	            },
	            complete: function() {
	                $('#btnSubmitSampleReq').prop('disabled', false);            
	            }
	        }); 
        }
    }

    function CancelSampleRequest() {
        $('#SampleRequestForm').toggle('100', function () {
            $(this).remove();
            $('#sampleReqCustomize').hide();
        });
    }

     //clear float when image section is taller than customize section
     function clearFloat(){
    		var isDesktop = $('.prodNumber').css('float') == 'none';
    		var isTabMobile = $('.prodNumber').css('float') == 'left';
     	     //add margin to push details down and floatleft
	     if (isDesktop){
		   	var imageHeight = 370 + $('.extraImgsBox').height(),
		   		infoHeight = $('.prodInfo').height(),
		   		summaryHeight = $('.prodSummary').height(),
		   		infoSummary = infoHeight + summaryHeight;
		   		
		   	if (imageHeight > infoSummary){
		   		var H = imageHeight - infoSummary;
		   		$('.prodSummary').css({'margin-bottom': H});
		   	}
	   	}
	   	//don't add the extra margin
	   	else if (isTabMobile){
	   		$('.prodSummary').css({'margin-bottom': '20px'});
	   	}
   	}
   	
   	function ByPassFullColor(){
   		$('.colorChipsCount').each(function(){
   			if($(this).val() == '1'){
   				$(this).parent().siblings('.imprint-colors-content').hide();
   				var spnColorChip =  $(this).parent().siblings('.imprint-colors-content').find('.spnColorChip').first();
   				SaveImprintColor(spnColorChip);
   			}
   		});  	
   	}
   	function MoveZoomRight(element, increment){
		var left = element.css('left');
		if(left.length > 2){
			var leftNum = + left.substring(0,left.length-2);
			if(leftNum > -321){
				leftNum = leftNum - increment;
				if(leftNum < -321){
					leftNum = -321;
				}
			}
			element.css('left', leftNum + 'px');
		}
	}
	
	
	function MoveZoomLeft(element, increment){
			var left = element.css('left');
		if(left.length > 2){
			var leftNum = + left.substring(0,left.length-2);
			if(leftNum < 0){
				leftNum = leftNum + increment;
				if(leftNum > 0){
					leftNum = 0;
				}
			}
			element.css('left', leftNum + 'px');
		}
	}
	
	function MoveZoomUp(element, increment){
			var top = element.css('top');
		if(top.length > 2){
			var topNum = + top.substring(0,top.length-2);
			if(topNum < 0){
				topNum = topNum + increment;
				if(topNum > 0){
					topNum = 0;
				}
			}
			element.css('top', topNum + 'px');
		}
	}
	
	function MoveZoomDown(element, increment){
			var top = element.css('top');
		if(top.length > 2){
			var topNum = + top.substring(0,top.length-2);
			if(topNum > -401){
				topNum = topNum - increment;
				if(topNum < -401){
					topNum = -401;
				}
			}
			element.css('top', topNum + 'px');
		}
	}
	
	function DecreaseGlideValue(){
		var curVal = +$('input#txtQty').val();
		var step = glide.SteppingQty();
		var changeStep = step;
		for(var i = 1; i < glide.BreakArray().length - 2; i++){
			if(glide.BreakArray()[i+1] >= curVal){
				var breakRange = glide.BreakArray()[i + 1] - glide.BreakArray()[i];
				changeStep = (breakRange) /100;
				changeStep = Math.round(changeStep - (Math.round((breakRange) / changeStep % 1) - (breakRange) / changeStep % 1) * changeStep);
				if(changeStep % step != 0){
					changeStep = Math.floor(changeStep / step + 1) * step;
				}
				break;
			}
		}
		if(changeStep < 1){
			changeStep = step;
		}
		var newVal = curVal - changeStep;
		if(newVal < glide.MinBreakQty()){
			newVal = glide.MinBreakQty();
		}
		$("#GlideSlider").sliderglide("value", glide.SetSlideQty(newVal));
	}
	
	function IncreaseGlideValue(){
		var curVal = +$('input#txtQty').val();
		var step = glide.SteppingQty();
		var changeStep = step;
		for(var i = 1; i < glide.BreakArray().length - 2; i++){
			if(glide.BreakArray()[i+1] > curVal){
				var breakRange = glide.BreakArray()[i + 1] - glide.BreakArray()[i];
				changeStep = (breakRange) /100;
				changeStep = Math.round(changeStep - (Math.round((breakRange) / changeStep % 1) - (breakRange) / changeStep % 1) * changeStep);
				if(changeStep % step != 0){
					changeStep = Math.floor(changeStep / step + 1) * step;
				}
				break;
			}
		}
		if(changeStep < 1){
			changeStep = step;
		}
		var newVal = curVal + changeStep;
		if(newVal > glide.MaxBreakQty()){
			newVal = glide.MaxBreakQty();
		}
		$("#GlideSlider").sliderglide("value", glide.SetSlideQty(newVal));
	
    }
    
	$('.three60View').on('keydown', function(e){
		//e.preventDefault();
		var keyCode = e.keyCode || e.which;
		if(keyCode == 37){
			var pos = Determine360Position();
			Set360Position(pos + 1);
		}
		else if(keyCode == 39){
			var pos = Determine360Position();
			Set360Position(pos - 1);
		}
	});
	//360view accessibility code
	var mapPos = [];
	function Get360Map(){
		if(mapPos.length == 0){
			try{
				var positions = $('#hyp360ViewZOOM').css('background-position').split(',');
				var imagePattern = /\/[0-9][0-9].jpg/;
				var images = $('#hyp360ViewZOOM').css('background-image').split(',');
				for(var i = 0; i < positions.length; i++){
					var matches = imagePattern.exec(images[i]);
					mapPos.push( +matches[0].substring(1,3) - 1);
				}
			}catch(e){}
		}
		return mapPos;
	}
	function Determine360Position(){
		try{		
			var positions = $('#hyp360ViewZOOM').css('background-position').split(',');
			
			for(var i = 0; i < positions.length; i++){
				if(positions[i].trim() == '0px 0px'){
					return Get360Map()[i];
					
				}
			}
		}
		catch(e){}
		
	}
	
	function Set360Position(position){
		try{
			var positions = $('#hyp360ViewZOOM').css('background-position').split(',');
			var pos = (position + positions.length) % positions.length;
			var bgPositions = [];
			for(var i = 0; i < positions.length; i++){
				if(Get360Map()[i] == pos){
					bgPositions.push('0px 0px');
				}else{
					bgPositions.push('0px -10000px');
				}
			}
			$('#hyp360ViewZOOM').css('background-position', bgPositions.join(', '));
	
		}catch(e){}
	}
   	
    /* ---- END NAMED LOCAL FUNCTIONS DECLARATIONS ----*/

    
    //RenderToolTips();
    
    
	/*
	// EMAIL
	$('body').on('click', '.openEmail', function(e){
        //if (e.type =='keypress' && !(e.which == 13)) { return;}
		var Email = $('#emailPopout');
		var trigger = $(this);
		if(Email.length > 0){
			//$('.emailSent').remove();
			Email.toggle('slow');
			$('.openEmail').removeClass('bkgdLtGray').addClass('bkgdMdGray');
			return false;
		}
		else {
			$.ajax({
				url: '/product/emailus',
				type: "GET",
				contentType: 'application/json',
				dataType: 'html',
				success: function (result) {
					$('.contactPanel').append(result);
					$('#emailPopout').toggle('slow');
					$('.openEmail').removeClass('bkgdMdGray').addClass('bkgdLtGray');
					$('#email').focus();
				},
				error: function () {
	
				}
			});
		}
	});

	
	// SUBMIT EMAIL
	$('body').on('click', '.submitEmail', function (e) {
        //if (e.type =='keypress' && !(e.which == 13)) { return;}
		var filter = /^([\w-&+\']+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,66}(?:\.[a-z]{2})?)$/i;
		var email = $('#email').val();
		var questions = $('#questions').val().trim();
		var triggerElement = $(this);
		$('.ErrorMsgPanel > ul').html('');
		$('.emailSent').remove();

		var isFormValid = true;
		if (email !== "" && !filter.test(email)) {
			$('#email').css("backgroundColor", '#ffd9d9').attr("aria-invalid", "true");
			$('.ErrorMsgPanel > ul').append('<li><a href="#email" role="link" tabindex="0">Please enter a valid Email Address</a></li>');
			$('.ErrorMsgPanel').show();
			$('.ErrorMsgPanel > ul > li:first-child').find('a').focus();
			isFormValid = false;
		} else if (email === "") {
			$('#email').css("backgroundColor", '#ffd9d9').attr("aria-invalid", "true");
			$('.ErrorMsgPanel > ul').append('<li><a href="#email" role="link" tabindex="0">Please enter an Email Address</a></li>');
			$('.ErrorMsgPanel').show();
			$('.ErrorMsgPanel > ul > li:first-child').find('a').focus();
			isFormValid = false;
		} else {
			$('#email').css("backgroundColor", '#ffffff');
		}
		if (questions === "") {
			$('#questions').css("backgroundColor", '#ffd9d9').attr("aria-invalid", "true");
			$('.ErrorMsgPanel > ul').append('<li><a href="#questions" role="link" tabindex="0">Please include Question/Comments</a></li>');
			$('.ErrorMsgPanel').show();
			$('.ErrorMsgPanel > ul > li:first-child').find('a').focus();
			isFormValid = false;
		} else {
			$('#questions').css("backgroundColor", '#ffffff').attr("aria-invalid", "false");
		}

		if (!isFormValid) { return isFormValid; } else { $('.ErrorMsgPanel').hide(); }

		var data = { from: email, catalogAlias: catAlias, questions: questions , emailUS: true };
		
		if($(this).hasClass('emailYourself')){ 	data = { from: email, catalogAlias: catAlias, questions: questions , emailUS: false };	}
		
		$.ajax({
			url: '/product/submitquestions',
			type: "POST",
			datatype: 'json',
			contentType: "application/json",
			data: JSON.stringify(data),
			success: function (result) {
				if (result.success == 'true') {
					if(triggerElement.hasClass('emailYourself')){
						$('.ErrorMsgPanel').after('<div class="emailSent paddingTop15" aria-live="polite"><h3 class="text16 paddingBtm10 textBlue">Thank you!</h3><p>Your email has been sent to ' + email +'</p></div>');
					} else {
						$('.ErrorMsgPanel').after('<div class="emailSent paddingTop15" aria-live="polite"><h3 class="text16 paddingBtm10 textBlue">Thank you!</h3><p>Your email has been received. One of our customer service representatives will respond shortly.</p></div>');
					}
					$('#email').val('');
					$('#questions').val('');
					$('.cancelEmail').focus();
				} else {
					$('.ErrorMsgPanel > ul').html('').append('<li aria-live="polite">Please try again later.</li>');
					$('.ErrorMsgPanel').show();
				}
			},
			error: function () {
				$('.ErrorMsgPanel > ul').html('').append('<li aria-live="polite">Please try again later.</li>');
				$('.ErrorMsgPanel').show();
			}
		});
	});
	
	// CANCEL EMAIL
	function CancelEmail() {
		$('#emailPopout').hide('slow', function () {
			$('#emailPopout').detach();
			$('.openEmail').removeClass('bkgdLtGray').addClass('bkgdMdGray');
			$('.openEmail').after('<span class="visually-hidden" aria-live="polite">Your email request has been cancelled</span>');
			//$('.ErrorMsgPanel').hide();
			//$('#email').css("backgroundColor", '#ffffff').attr('aria-invalid', 'false');
			//$('#questions').css("backgroundColor", '#ffffff').attr('aria-invalid', 'false');
		});
	}
    
	$('.contactPanel').on('click', '.cancelEmail', function(e){
        //if (e.type =='keypress' && !(e.which == 13)) { return;}
		CancelEmail();
	});
*/

	

    if (editID < 0) {
    	  //check first location and display imprint colors if more than one
        $('.chkbxImprintLocation').first().prop('checked', true);
        if (totalImprintColors > 0) {
            $('.chkbxImprintLocation').first().parent().siblings('.imprint-colors-content').show();
        }
    } else {
    	   //cart item is being edited.. show imprint colors for all checked imprint locations
    		if(totalImprintColors != undefined && totalImprintColors > 0){
        		$('.chkbxImprintLocation:checked').first().parent().siblings('.imprint-colors-content').show();
        } else{
        	$('.chkbxImprintLocation:checked').first().parent().siblings('.imprint-colors-content').hide();
        }
         $('.imgActive').find('.prodImgSelected').trigger("click");
    }

   //checks for full color (CYMK), or items with only 1 imprint color
   //will save imprint colors so that add to cart will be activated  - also saves the user that extra click

    clearFloat();
    ValidateCustomizeSections();
		
	var slider = $('#photoSwipeBox').slick('getSlick');
	if(slider.slideCount == 1){
		$('#photoSwipeBox').find('.slick-arrow').hide();
		//$('#photoSwipeBoxWrapper').css('margin', '0 auto');
	}

    $('.thumbSelectImage').each(function () {
        $('#' + this.id).on("click keypress", function (e) {
            if (e.type =='keypress' && !(e.which == 13)) { return;}
            var vals = this.id.split('_');
            $("#photoSwipeBox").slick('slickGoTo', vals[1]);
        });
    });
	
	//change border of slide that is currently being viewed
	$("#photoSwipeBox").on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		$('.thumbSelectImage').removeClass('borderDkGray').addClass('borderMdGray');
		// before animation between slides start
		//var slideNumber = nextSlide;
		 $('#thumbSelectImage_' + nextSlide).removeClass('borderMdGray').addClass('borderDkGray');
	});

   
    //detailsTab
    function setDetailTabEvents(){ 

        initReviewPages();
        initReviewFilters();
        initSuccessPages();
        initFitRatingPages();
        initQAPages();

        //fitRating
        $('.filterTag').each(function () {
            $('#' + this.id).on("click", function (e) {
                //if (e.type =='keypress' && !(e.which == 13)) { return;}
                e.preventDefault();
                var vals = this.id.split('_');
                var filter = '';
                if (vals.length > 1) {
                    filter = vals[1];
                    $('#fitratingfilter').show();
                    $('#fitratingfilter').removeClass('hide');
                }else{
                    $('#fitratingfilter').hide();
                    $('#fitratingfilter').addClass('hide');
                }
                loadingPage();
                $.ajax({
                    url: "/productmvc/customerfitrating/" + prodID + "/1/" + filter,
                    type: "GET",
                    contentType: 'application/json',
                    dataType: 'html',
                    success: function (result) {
                        $('#customerfitcomments').html('');
                        $('#customerfitcomments').html(result);
                        hideLoading();
                        initFitRatingPages();
                        $('#fitratingfilter');
                    },
                    error: function(){
                            hideLoading();
                            //add error msg?
                    }
                });
                return false;
            });
        });

        $('.detailsTabSelect').each(function () {
            $('#' + this.id).on("click keypress", function (e) {
                if (e.type =='keypress' && !(e.which == 13)) { return;}
                $('.detailsTabSelect').removeClass('bkgdBlue textWhite').addClass('bkgdMdGray');
                $('.detailsTabSelect').attr({
                        'aria-selected': 'false'
                    });
                $('#' + this.id).removeClass('bkgdMdGray').addClass('bkgdBlue textWhite');
                $('#' + this.id).attr({
                        'aria-selected': 'true',
                        'tabindex': '0'
                });
                $('.detailsTab').addClass('hide').hide();
                $('.detailsTab').attr('aria-hidden', 'true');
                $('.detailsTab').attr('aria-expanded', 'false');
                $('#' + this.id + 'Tab').removeClass('hide').show();
                $('#' + this.id + 'Tab').attr('aria-hidden', 'false');
                $('#' + this.id + 'Tab').attr('aria-expanded', 'true');
                $('.detailsTabArrow').removeClass('rotate180').addClass('rotate90');
                $('#' + this.id + 'Arrow').removeClass('rotate90').addClass('rotate180');
            });
        });//end detailsTab

        $('body').on('click', '.questionText', function (e) {
            //if (e.type =='keypress' && !(e.which == 13)) { return;}
            e.preventDefault();
            
            var el = $(this).parent().parent().siblings('.answerQuestion');
            if (el.hasClass('hide'))
            {
            	  $(this).attr("aria-expanded", "true");
                el.removeClass('hide').show();
                el.find(".prodAnswer").focus();
            }else{
                el.addClass('hide').hide();
                $(this).attr("aria-expanded", "false").focus();
            }

        });

        //positive and negative QA submit
        $('body').on('click', '.positiveAnswer', function (e) {
            //if (e.type =='keypress' && !(e.which == 13)) { return;}
            e.preventDefault();
            var reviewID = $(this).siblings('.QA_ID').val();
            var neg = $(this).siblings('.negativeAnswer');
            var data = { answerID: reviewID, answerHelful: true,  catalogAlias: catAlias};
            $.ajax({
                url: "/product/answerhelpful",
                type: "POST",
                magic: $(this),
                data: JSON.stringify(data),
                contentType: 'application/json',
                dataType: 'json',
                success: function (result) {
                    if (result.success == "true") {
                        this.magic.before('<p class=\'textBlue textsemibold reviewRemarkMsg marginBtm10\' role=\'status\'>' + result.message + '</p>');
                        neg.addClass('hide').hide();
                        this.magic.addClass('hide').hide();
                    } else {
                        this.magic.before('<div class=\'clear\'></div><p class=\'textDkRed textsemibold reviewRemarkMsg marginBtm10\' role=\'status\'>' + result.message + '</p>');
                        neg.addClass('hide').hide();
                        this.magic.addClass('hide').hide();
                    }
                }
            });
        });
        
        $('body').on('click', '.negativeAnswer', function (e) {
            //if (e.type =='keypress' && !(e.which == 13)) { return;}
            e.preventDefault();
            var reviewID = $(this).siblings('.QA_ID').val();
            var pos = $(this).siblings('.positiveAnswer');

            var data = { answerID: reviewID, answerHelful: false,  catalogAlias: catAlias };
            $.ajax({
                url: "/product/answerhelpful",
                magic: $(this),
                type: "POST",
                data: JSON.stringify(data),
                contentType: 'application/json',
                dataType: 'json',
                success: function (result) {
                    if (result.success == "true") {
                        this.magic.after('<div class=\'clear\'><p class=\'textBlue textsemibold reviewRemarkMsg marginTop10\' role=\'status\'>' + result.message + '</p>');
                        pos.addClass('hide').hide();
                        this.magic.addClass('hide').hide();
                    } else {
                        this.magic.after('<div class=\'clear\'><p class=\'textDkRed textsemibold reviewRemarkMsg marginTop10\' role=\'status\'>' + result.message + '</p>');
                        pos.addClass('hide').hide();
                        this.magic.addClass('hide').hide();
                    }
                }
            });
        });

        $('body').on('click', '.btnSubmitProdAnswer', function (e) {
            //if (e.type =='keypress' && !(e.which == 13)) { return;}
            e.preventDefault();
            var vals = this.id.split('_');
            var question_ID = vals[1];
            var answer = $('#answerQuestion_' + question_ID);
            var pos = $(this).siblings('.positiveAnswer');

            $('.prodAnswerMsg').remove();
            if(answer.val().trim().length < 2){
                answer.css('background-color', '#ffd9d9').attr('aria-invalid', 'true').focus();
                $('#submitAnswer_'+question_ID).parent().after('<p class=\"prodAnswerMsg clear textsemibold marginTop10 textDkRed\" role=\"alert\">' + localizedJS.InvalidAnswerMsg + '</p>');
                return false;
            } else {
                answer.css('background-color', 'transparent').removeAttr('aria-invalid');
            }
            var data = { productID: prodID, questionID: question_ID, quickAnswer: answer.val() };
            $.ajax({
                url: "/product/submitquickanswer",
                magic: $(this),
                type: "POST",
                data: JSON.stringify(data),
                contentType: 'application/json',
                dataType: 'json',
                success: function (result) {
                    if (result.success == "true") {
                        this.magic.after('<div class=\'clear\'><p class=\'textBlue textsemibold prodAnswerMsg marginTop10\' aria-live=\'polite\'>' + result.message + '</p>');
                        pos.addClass('hide').hide();
                        this.magic.addClass('hide').hide();
                    } else {
                        this.magic.after('<div class=\'clear\'><p class=\'textDkRed textsemibold prodAnswerMsg marginTop10\' role=\'alert\'>' + result.message + '</p>');
                        pos.addClass('hide').hide();
                        this.magic.addClass('hide').hide();
                    }
                }
            });
        });

        if (localizedJS.showCustomerImages) {
            initCustomerImagesPages();
        }
        
    
        //tabs keyboard accessibility
        $('.detailsTabSelect').on("keydown", function (e) {
            // Listen for the up, down, left and right arrow keys, otherwise, end here
            if ([37, 38, 39, 40].indexOf(e.which) == -1) {
                return;
            }
            switch (e.which) {
                case 37: // left arrow
                case 38: // up arrow
                    e.preventDefault();
                    e.stopPropagation();
                    if ($('.detailsTabSelect').first().is(':focus')) {
                        $('.detailsTabSelect').filter(':visible').last().focus().click();
                    } else {
                        $(this).prev('.detailsTabSelect').filter(':visible').focus().click();
                    }
                    break;
                case 39: // right arrow
                case 40: // down arrow
                    e.preventDefault();
                    e.stopPropagation();
                    if ($('.detailsTabSelect').filter(':visible').last().is(':focus')) {
                        $('.detailsTabSelect').first().focus().click();
                    } else {
                        $(this).next('.detailsTabSelect').filter(':visible').focus().click();
                    }
                    break;
            }
        });
        
        //positive and negative review submit
        $('body').on('click keyup', '.positiveReview', function (e) {
            if (e.type =='keyup' && !(e.which == 13)) { return;}
            e.preventDefault();
              $('.reviewRemarkMsg').fadeOut('slow').remove();
            var reviewID = $(this).siblings('.reviewID').val();
            var data = { reportSKU: reportSKU, reviewID: reviewID, positiveReview: true, negativeReview: false, catalogAlias: catAlias };
            $.ajax({
                url: "/productmvc/reviewremark",
                type: "POST",
                magic: $(this),
                data: JSON.stringify(data),
                contentType: 'application/json',
                dataType: 'json',
                success: function (result) {
                    if (result.success == "true") {
                        this.magic.before('<p class=\'clear textBlue textsemibold reviewRemarkMsg marginBtm10\' role=\'status\'>' + result.message + '</p>');
                    } else {
                        this.magic.before('<p class=\'clear textDkRed textsemibold reviewRemarkMsg marginBtm10\' role=\'status\'>' + result.message + '</p>');
                    }
                }
            });       
            //$(this).off(event);
        });
    
       $('body').on('click keyup','.negativeReview', function (e) {
            if (e.type =='keyup' && !(e.which == 13)) { return;}
            e.preventDefault();
            $('.reviewRemarkMsg').fadeOut('slow').remove();
            var reviewID = $(this).siblings('.reviewID').val();
            var data = { reportSKU: reportSKU, reviewID: reviewID, positiveReview: false, negativeReview: true, catalogAlias: catAlias };
            $.ajax({
                url: "/productmvc/reviewremark",
                magic: $(this),
                type: "POST",
                data: JSON.stringify(data),
                contentType: 'application/json',
                dataType: 'json',
                success: function (result) {
                    if (result.success == "true") {
                        this.magic.after('<div class=\'clear\'></div><p class=\'textBlue textsemibold reviewRemarkMsg marginTop10\' role=\'status\'>' + result.message + '</p>');
                    } else {
                        this.magic.after('<div class=\'clear\'></div><p class=\'textDkRed textsemibold reviewRemarkMsg marginTop10\' role=\'status\'>' + result.message + '</p>');
                    }
                }
            });
        });//end positive review submit   

           
        $('#miniReviewLink').on("click", function(e){
            //if (e.type =='keypress' && !(e.which == 13)) { return;}
           //e.preventDefault();
            $('#reviewsTS').trigger('click');
            ScrollToElement('.detailsTabSelect');
            return false;
        });
    
        $('body').on("click", ".exitReadAll", function (e) {
            //if (e.type =='keypress' && !(e.which == 13)) { return;}
            $('.viewModeAll').fadeOut('slow', function () { });
            $('.viewModeAll').remove();
            $('.halfPageContent').fadeIn('slow', function () { });
        });
    
        $('body').on("click", ".readMoreAnswers", function (e) {
            //if (e.type =='keypress' && !(e.which == 13)) { return;}
            $('.product-moreanswers-dropdown').hide("slow", function () { });
            if ($(this).siblings('.product-moreanswers-dropdown').is(":hidden")) {
                $(this).siblings('.product-moreanswers-dropdown').slideDown("slow", function () { });
            } else {
                $(this).siblings('.product-moreanswers-dropdown').hide("slow", function () { });
            }
        });
    
        $('body').on("click", ".cancelQuickAnswer", function (e) {
            //if (e.type =='keypress' && !(e.which == 13)) { return;}
            $('.quickAnswerContent').hide('slow', function () { });
            $('.quickAnswerContent').remove();
            $('.addQuickAnswer').show();
        });
    
        $('.addQuickAnswer').on("click", function e() {
            //if (e.type =='keypress' && !(e.which == 13)) { return;}
            $('.quickAnswerContent').hide('slow', function () { });
            $('.addQuickAnswer').show();
            $('.quickAnswSubmitMsg').remove();
            $('.quickAnswerContent').remove();
            $(this).after('<div class=\'quickAnswerContent\' ><textarea class=\"newQuickAnswer floatLeft\" col=\'4\', rows=\'5\'></textarea> <input value=\'Submit Answer\' type=\'button\' class=\'clear submitQuickAnswer button-md-thin text14 bkgdBlue whiteLink floatLeft\' />' +
                '<input value=\'Cancel\' type=\'button\' class=\'cancelQuickAnswer clear button-md-thin button-white-textBlue\' /></div>').hide();
    
            $('.quickAnswerContent').slideDown('slow', function () { });
        });
    
        $('body').on('click', '.submitQuickAnswer', function (e) {
            //if (e.type =='keypress' && !(e.which == 13)) { return;}
            var quickAnswer = $(this).siblings('.newQuickAnswer').val();
            var questionID = $(this).parent().siblings('.questionID').val();
            var data = { productID: prodID, questionID: questionID, quickAnswer: quickAnswer };
            $('.quickAnswSubmitMsg').remove();
            $.ajax({
                url: "/productmvc/submitquickanswer",
                type: "POST",
                data: JSON.stringify(data),
                contentType: 'application/json',
                dataType: 'json',
                success: function (result) {
                    $('.quickAnswerContent').html('');
                    if (result.success == "true") {
                        $('.addQuickAnswer').show();
                        //display message
                        $('.quickAnswerContent').after('<span class=\"quickAnswSubmitMsg textBlue\" aria-live=\"polite\">' + result.message + '</span>');
                    } else {
                        //notify user there was an error
                        $('.addQuickAnswer').show();
                        $('.quickAnswerContent').after('<span class=\"quickAnswSubmitMsg textDkRed\" role=\"alert\">' + result.message + '</span>');
                    }
                }
            });
        });
    
        $('body').on('click', '.btnSubmitProdQuestion', function (e) {
            //if (e.type =='keypress' && !(e.which == 13)) { return;}
            $('.prodQuestionMsg').remove();
            if ($('textarea.productQuestion').val().trim().length < 6) {
                $('.productQuestion').css("background-Color", "#ffd9d9").attr('aria-invalid', 'true');
                $('.submitQuestion').after('<p class=\"prodQuestionMsg clear textsemibold marginTop10 textDkRed\" role=\"alert\">' + localizedJS.InvalidQuestionMsg + '</p>');
                $('#prodQstn').focus();
                return false;
            } else {
                $('.productQuestion').css("background-Color", "transparent").removeAttr('aria-invalid');
            }
            var data = { catalogAlias: catAlias, productQuestion: $('textarea.productQuestion').val() };
            $('.prodQuestionMsg').remove();
            $.ajax({
                url: "/productmvc/saveproductquestion",
                type: "POST",
                data: JSON.stringify(data),
                contentType: 'application/json',
                dataType: 'json',
                success: function (result) {
                    if (result.success == "true") {
                        //display message
                        $('.submitQuestion').after('<p class=\"prodQuestionMsg clear textsemibold marginTop10 textBlue\" aria-live=\"polite\">' + result.message + '</p>');
                        $('textarea.productQuestion').val('');
                    } else {
                        //notify user there was an error
                        $('.submitQuestion').after('<p class=\"prodQuestionMsg clear textsemibold marginTop10 textDkRed\" role=\"alert\">' + result.message + '</p>');
                        $('#prodQstn').focus();
                    }
                }
            });
        });


    };

    if(!isMobile){
    	 loadMainZoom();
    	 $("#photoSwipeBox").on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		 cleanExtraZoom();
		 cleanMainZoom();
        	 loadExtraZoom();
		 loadMainZoom();
	});
    	 
        /*region item customization / summary*/
        $('body').on("click keyup", ".nextStep", function (e) {
            if (e.type =='keyup' && !(e.keyCode == 13)) { return;}
            $('.errorMsg').remove();
            var colorSelected = $('#colorSelected').val();
            var selectedColorID = selBaseTrim.val();
            var qty = GetQty();
            var priceEach = $("#lblPrice").html();
            var grandTotal = $('#lblTotal').html();
        
            if ($(this).hasClass('step1')) {
                ResetImprintCharges();
                if (isApparelItem && $('#SizingGrid').html().length > 0) {
                    CalcPrice();
                }
                if (selectedColorID == undefined || selectedColorID == "") {
                    if(recolorAvailable == 'True'){
                        $('.Scroller').first().before('<p class="textDkRed errorMsg padding10 marginTop15 borderDkRed textsemibold" role="alert">Please select a ' + localizedJS.Color + ' option from the list provided</p>');
                        $('.Scroller').find('.imgBox').first().find('a').focus();
                } else{
                        $('.PD_ColorList').before('<p class="textDkRed errorMsg padding10 marginTop15 borderDkRed textsemibold" role="alert">Please select a ' + localizedJS.Color + ' option from the list provided</p>');
                        $('#listView').find('.selectedImgDesc').first().focus();
                    }
                    ScrollToElement('.PD_Step_1');
                    return false;
                }
                if (qty == NaN || qty == undefined || qty == '0' || !IsNumeric(qty)) {
                    $('.qtyErrorMsg').remove();
                    $('.txtApparelQty').css('background-color', '#ffd9d9').attr('aria-invalid', 'true').first().focus();
                    $('input#txtQty').css('background-color', '#ffd9d9').attr('aria-invalid', 'true').focus();
                    $('#chooseQuant').before('<p class="qtyErrorMsg textDkRed errorMsg padding10 borderDkRed margin15 textsemibold" role="alert">Please enter a valid quantity. Minimum quantity for this item is ' + lowestQty + '</p>');
                    ScrollToElement('.qtyErrorMsg');
                    return false;
                }
                if (qty < lowestQty) {
                    $('.txtApparelQty').each(function () {
                        if ($(this).val() != '') {
                            $(this).css('background-color', '#ffd9d9').attr('aria-invalid', 'true');
                        }
                    });
                    $('.qtyErrorMsg').remove();
                    $('h2.stepOneHdr').after('<p class="qtyErrorMsg textDkRed errorMsg padding10 borderDkRed margin15 textsemibold" role="alert">Minimum quantity for this item is ' + lowestQty + '.</p>');
                    $('input#txtQty').css('background-color', '#ffd9d9').attr('aria-invalid', 'true').focus();
                    ScrollToElement('.qtyErrorMsg');
                    return false;
                }
                if (qty >= lowestQty && selectedColorID != "") {
                    $('.qtyErrorMsg').remove();
                    $('input#txtQty').removeAttr('style').removeAttr('aria-invalid');
                    $('.PD_Step_1').fadeOut('50', function () {
                        $('.PD_Step_2').fadeIn('50', function () {
                            //if (optionalExtras == null) {
                                LoadOptionalExtras();
                            //}
                            //if (nibInkOptions == null) {
                                LoadNibInkColor();
                            //}
                            //if (adhSidesOptions == null) {
                                LoadAdhesiveOptions();
                            //}
                            if (qryStr > 0){
                                CheckQueryString();

                                var gFeedSummary = '<div class="GFeedPanel1">';
                                gFeedSummary += $('#GFeedPanel').html() + '</div>';
                                $('#GFeedPanel').html('');

                                if(totalImprintColors > 0){
                                    $('.chkbxImprintLocation:checked').first().parent().parent().find('.imprintButtonExtras').addClass('hide').after(gFeedSummary);
                                } else{
                                    $('.imprintButtonExtras').addClass('hide').after(gFeedSummary);
                                }
                            }
                            ScrollToElement('.PD_Step_2', 500);
                        });
                    });
                }
            } else if ($(this).hasClass('goToStep1')) {
                $('.PD_Step_2').fadeOut('50', function () {
                var gFeedSummary = $('.GFeedPanel1').html();
                    $('#GFeedPanel').html(gFeedSummary).show();
                    $('.GFeedPanel1').remove();
                    $('.PD_Step_1').fadeIn('50');
                    ScrollToElement('.PD_Step_1',500);
                    var inputs = $('.PD_Step_1').find('.selectedImgDesc[tabindex], select, input, textarea, button, a[href]').filter(':visible').not(':disabled');
            inputs.first().focus();
            // if(recolorAvailable == 'True'){
                //	$('.Scroller').find('.imgBox').first().find('a').focus();
                //  }else {
            //	$(".selectedImgDesc").first().focus();
            // }
                });
                e.preventDefault();
            }
        });
        /*end customization*/


    }
	/* 360 view dialog */
	if($("#hyp360View").length){
		var threeSixtyDialog = dialog4i();
		threeSixtyDialog.init(document.getElementById('PD_360Flyout'), document.getElementsByClassName("PD_360"));
	}
	$(".DetailsProdImg").on("click", function(e){
		e.preventDefault();
	});

    //give 360 box appropriate class for styling
    $('.PD_360').on("click", function (e) {
        //if (e.type =='keypress' && !(e.which == 13)) { return;}
        e.preventDefault();
        lazyloadImages.update();
	    var boxWidth = $('#flyoutImg').width(),
			boxHeight = $('#flyoutImg').height();
	    if (boxWidth > boxHeight) {
	        $('.three60View').addClass('landscape');
	    }
	    else { $('.three60View').addClass('portrait'); }	
	});
	$('.PD_360').on("keyup", function(e){
	 	e.preventDefault();
		if(e.keyCode=='13'){
			$(this).click();
		}
	});
    $('.otherImagesJS').on("click", function (e) {
        e.preventDefault();
    });

    

    $(function () {
        currencySymbol = currencySymbol.replace(/\s+/g, '');
        Glide4imprint() / GlideInit(arrBreak, arrPrice, steppingQty);
        var selectedColorID = selBaseTrim.val();
        if (selectedColorID != "") {
            $('.selectedColorID').each(function () {
                if ($(this).val() == selectedColorID) {
                    $(this).siblings('.selectedImgDesc').addClass('textWhite bkgdBlue').removeClass('colorText').children('.selectedImgOutOfStockDesc').addClass('textWhite').removeClass('textRed');
                    $(this).parent('.imgBox').addClass('imgActive');
                }
            });
        }
    });

    

    //imprint location checkbox
    $('body').on("click", ".chkbxImprintLocation", function (e) {
        //if (e.type =='keyup' && !(e.which == 13)) { return;}
        $('#GFeedData').hide('');
        $('.imprintButtonExtras').removeClass('hide');
        ResetImprintCharges();
        if ($(this).prop('checked') == true) {
            if (totalImprintColors > 0 && $(this).siblings('.colorChipsCount').val() != '1') {
                $(this).parent().siblings(".imprint-colors-content").fadeIn("slow", function () { });
            }
            if ($(this).siblings('.inputIsExcl').val() == "True") {
                $('.chkbxImprintLocation').not($(this)).prop('checked', false);
            } else {
                $('.chkbxImprintLocation:checked').each(function () {
                    if ($(this).siblings('.inputIsExcl').val() == "True") {
                        $(this).prop('checked', false);
                    }
                });
            }
        }else{
        	$(this).parent().siblings().find('.clearAllColors').click();
        	$(this).parent().siblings().fadeOut("slow", function () { }); 
        }
        ValidateCustomizeSections();
    });//end imprint location selection

	$('body').on("keyup", ".chkbxImprintLocation", function (e) {
         if (e.type =='keyup' && !(e.which == 13)) { return;}
		$(this).click();
	});
    //glide init
    if(!isSuspended) SetupGlide();

    if (!$('.PD_SelectionBox').hasClass('hide')) {
        $('.PD_SelectionPanel').slideToggle();
    }

    CheckForSingleQtyBreak();

    // Click events for the buttons
    $('.PD_QuantityBtnCell input').on("click", function () {
        if (!variableDefined('searchClicked') || (variableDefined('searchClicked') && searchClicked == false)) {
            SetQuantity(); return false;
        }
    });

    $("#SizingGrid").on("keyup focusout", ".txtApparelQty",function (e) {
        $('.txtApparelQty').css('background-color', '#ffffff').removeAttr('aria-invalid');
        if (IsNumeric($(this).val())) {             	
            var thisQty = 0;
            $('.txtApparelQty').each(function () {
                if ($(this).val() != '') {     
                        if( IsNumeric($(this).val())){
                            thisQty += parseInt($(this).val());   
                        }
                }
            });

            var updateDelay = (thisQty < lowestQty) ? 750 : 600;

            txtTimer = setTimeout( function(){
                    $('#txtQty').siblings('input').remove();
                    CalcPrice();
                }, updateDelay);
        } else{
        	$(this).val('');
        	$(this).focus();
        	return false;
        }
        return true;
    });
    
   $('body').on("click", ".addMoreSizes", function (e) {
       //if (e.type =='keypress' && !(e.which == 13)) { return;}
        e.preventDefault();
   	    $('.moreSizes').fadeIn('200');
	    var newLabel = $(this).val().replace('Add', 'Clear All');
	    $(this).val(newLabel).removeClass('addMoreSizes').addClass('clearAllSizes');	  
   });	
	
    $('body').on("click", ".clearAllSizes", function (e) {
        //if (e.type =='keypress' && !(e.which == 13)) { return;}
        e.preventDefault();
   	    $('.moreSizes').fadeOut('200').find('.txtApparelQty').val('');
	    var newLabel = $(this).val().replace('Clear All', 'Add');
	    $(this).val(newLabel).removeClass('clearAllSizes').addClass('addMoreSizes');
	    CalcPrice();	  
   });
	
    if(totalProductImages == 1 || editID > 0){
    	$('.step1').removeClass('disabledBtn').addClass('bkgdBlue whiteLink');
    }
    $('.sampleRequest1').on("click", function (e) { 
        //if (e.type =='keypress' && !(e.keyCode == 13)) { return;}
        e.preventDefault();
        SampleRequest(); 
        
    }); 
     $('body').on("click", '#cancelRequest', function(e) {
        //if (e.type =='keypress' && !(e.which == 13)) { return;}
		e.preventDefault();
		CancelSampleRequest();
		$('.sampleRequestPanel').after('<p class="sampleCancel clear textsemibold marginTop10 textBlue" role="status">Your sample request has been cancelled.</p>');
    		$('.sampleBtnContainer').show();
    });

    $('.gotoProdColors').on('click keypress', function(e) {
   	    if (e.type =='keypress' && !(e.which == 13)) { return;}
	    e.preventDefault();
    	ScrollToElement(".PD_Step_1");
       $('#productColorScroller').find('.imgBox').first().children('.selectedImgDesc').focus();
    });
 
    $('.addColors').on("click", function () { UnlockMoreColors(this, totalImprintColors); });
    $('.clearAllColors').on("click", function () { ClearImprintColors(this); });
    $('.closeColorPicker').on("click", function () { CloseColorPicker(this); });
    $('.spnColorChip').on('click keydown', function (e) { 
        if (e.type =='keydown' && !(e.keyCode == 13)) { return; }
        e.preventDefault();
    	SaveImprintColor(this); 
    });
    

    $('.calcExtrasBtn').on('click', function (e) {
        //if (e.type =='keypress' && !(e.which == 13)) { return;} 
        e.preventDefault();
        if($(this).siblings('.extrasResult').css('display') == 'none'){
            GetExtras(this);
            $('.calcExtrasBtn').val('Show Imprint Charges');
            $(this).val('Hide Imprint Charges');
        }else{
            $('.calcExtrasBtn').val('Show Imprint Charges');
            $(this).siblings('.extrasResult').hide(); 			
        }
	});
	var processing = false;
    $('.btnAddToCart').on('click', function (e) { 
        //if (e.type =='keypress' && !(e.which == 13)) { return;}
    	e.preventDefault();
   	e.stopPropagation();


    	if(!processing) {
    		processing = true;
    		AddToCart(this);
	}
    });
    
     $('body').on("click", ".imprintClearColor", function(e){  
    		e.preventDefault();
    		DeleteImprintColor(this);  
    });
    
    $('#txtQty').on('keyup', function(e){ 
		if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) {
			TextUpdateSliderFinish($(this).val(), true);
			$('.PD_QuantityBtnCell input').trigger('click');
		}else{
    			TextUpdateSlider(this.value, true);
        }
    		return false;
    });
    
    $('#hypMoreDetails').on("click=", function(e){ 
        //if (e.type =='keypress' && !(e.which == 13)) { return;}
        e.preventDefault(); 
        ScrollToElement('.prodDetails'); 
    });    
    
    if(!isApparelItem  && qryStr > 0){
    	  $('.selectedImgDesc').first().trigger("click");
    	  CheckQueryString();
    } else if(qryStr > 0 && totalProductImages > 1){
    	  $('#GFeedPanel').hide();  	 
    	  $('.selectedImgDesc').first().trigger("click");
    }else if(qryStr > 0 && totalProductImages == 1){
        $('.txtApparelQty').first().val(lowestQty);
        CalcPrice();
        CheckQueryString();
    }
  
   
    if (optionalExtras == null) { LoadOptionalExtras(); }
    if (nibInkOptions == null) { LoadNibInkColor();  }
    if (adhSidesOptions == null) { LoadAdhesiveOptions();  }
    
    ByPassFullColor();
    
    $(document).ready(function () { 
        switch(window.location.hash){
            case '#reviews':
                ScrollToElement('#detailTabs');
                setTimeout(function(){$('#reviewsTS').trigger('click');}, 1200);
    			break;
            case '#stories':
                ScrollToElement('#detailTabs'); 
                setTimeout(function(){$('#successStoriesTS').trigger('click');}, 1200);
    			break;
            case '#fit':
                ScrollToElement('#detailTabs');
                setTimeout(function(){$('#fitRatingTS').trigger('click');}, 1200);
			    break;
            case '#questions':
                ScrollToElement('#detailTabs');
                setTimeout(function(){$('#QATS').trigger('click');}, 1200);
			    break;
    		default:
    			break;
    			
        }
   	 if ($('#InfoType').length>0) { 
    		var InfoType = $('#InfoType').val();
    		switch (InfoType) {
    			case '1':             
                    ScrollToElement('#detailTabs');
                    setTimeout(function(){$('#reviewsTS').trigger('click');}, 1200);
    				break;
    			case '2':
                    ScrollToElement('#detailTabs');
                    setTimeout(function(){$('#successStoriesTS').trigger('click');}, 1200);
    				break;
    			case '3':
    				
                    ScrollToElement('#detailTabs');
                    setTimeout(function(){$('#fitRatingTS').trigger('click');}, 1200);
    				break;
    			case '4':	
                    ScrollToElement('#detailTabs');
                    setTimeout(function(){$('#QATS').trigger('click');}, 1200);
    				break;
    			default:
    				break;
    		
    		}
    	}
    });
    
    $(window).on("resize", clearFloat);
    function moveZoom(e){
    	
    	var keyCode = e.keyCode || e.which;
		var zoomMoveIncrement = 20;
		if(keyCode == 37){//left
			e.stopPropagation();
			e.preventDefault();
			MoveZoomLeft($(this).find('.zoomImg'), zoomMoveIncrement);
		}else if(keyCode == 38){//up
			e.stopPropagation();
			e.preventDefault();
			MoveZoomUp($(this).find('.zoomImg'), zoomMoveIncrement);
		}else if(keyCode == 39){//right
			e.stopPropagation();
			e.preventDefault();
			MoveZoomRight($(this).find('.zoomImg'), zoomMoveIncrement);
		}else if(keyCode == 40){//down
			e.stopPropagation();
			e.preventDefault();
			MoveZoomDown($(this).find('.zoomImg'), zoomMoveIncrement);
		}
    }
    
	$('#photoSwipeBox .slick-slide > div > div >  a').on('focus', function(){
		//$(this).find('.zoomWrapperImage > img').css('top','-200px');
		//$(this).find('.zoomWrapperImage > img').css('left','-200px');
		//$(this).find('.zoomWindow').css('display', 'block');
		$(this).find('img.zoomImg').css({'top': '-200px', 'left' : '-200px', 'opacity': '1'});
		$(document.activeElement).on('keydown', moveZoom);
	});
	$('#photoSwipeBox .slick-slide > div > div > a').on('blur', function(){
		$(this).find('img.zoomImg').css('opacity', '0');
		$(document.activeElement).off('keydown', moveZoom);
	});
	
    //catch key press for accessibility
   // document.onkeypress = catchKeyPress;
  
      $('#relatedProductsContainer').appear();
    var loadedRelated = false;
    $('#relatedProductsContainer').on('appear', function(e){
        e.stopPropagation();
        if(!loadedRelated){
            $('.loadingPagerp').removeClass('hide');
            loadedRelated = true;
            $.ajax({
                url: '/productmvc/GetRelatedProductsScrollerAsync',
                type: 'POST',
                data: { 'productID': prodID},
                success: function (data) {            
                    $('#relatedProductsContainer').append(data);
                    $('#relatedProductsContainer .spinner').addClass('hide');
                    //$('#relatedProductsContainer').off();
                    prodScrollerJS.InitRelatedItemsScroller();
                }
            });
        } 
    });
      
    $('#detailTabs').appear();
	var loadedDetailsTab = false;
    $('#detailTabs').on('appear', function(e){
        e.stopPropagation();
        if(!loadedDetailsTab){
            $('.loadingPagedt').removeClass('hide');
            loadedDetailsTab = true;
            $.ajax({
                    url: '/productmvc/GetDetailsTabAsync',
                    type: 'POST',
                    data: { 'productID': prodID, 'infoType': $('InfoType').val(), 'qID': $('#QuestionID').val(), 'rFilter': $('#ReviewFilter').val(), 'fitRatingFilter': $('#FitCommentFilter').val() },
                    success: function (data) {
                        
	                    $('#detailTabs').append(data);
	
	                    detailTabWidth();
	                    $(window).on("resize", detailTabWidth);
	                    setDetailTabEvents();
	                    $('#detailTabs .spinner').addClass('hide');
                    		FixIE11SVG();
                    }
                });
        }
    });

    $('.itemCats').appear();
    var loadeditemCats = false;
    $('.itemCats').on('appear', function(e){
        e.stopPropagation();
        if(!loadeditemCats){
            $('.loadingPageic').removeClass('hide');
            loadeditemCats = true;
            $.ajax({
                url: '/productmvc/GetItemCategoriesAsync',
                type: 'POST',
                data: { 'productID': prodID},
                success: function (data) {
                    
                    $('.itemCats').append(data);
                    $('.itemCats .spinner').addClass('hide');
                
                }
            });
        }
    });

    //tab product scroller
    $('#tabProd').appear();
    var loadedtabprod = false;
    $('#tabProd').on('appear', function(e){
        e.stopPropagation();
        if(!loadedtabprod){
            $('.loadingPagetp').removeClass('hide');
            loadedtabprod = true;
            $.ajax({
                url: '/productmvc/GetTabProductScrollerAsync',
                type: 'POST',
                data: { 'productID': prodID},
                success: function (data) {
                    
                    $('#tabProd').append(data);
                    
                    if(isMobile) {
                    		$("#MoreUpscaleItemsTab").parent().remove();
                    		$("#MoreUpscaleItemsPanel").remove();		
                    }
                    
            		prodScrollerJS.InitScrollerTabProd();
                    prodScrollerJS.InitTabs();
                    
                    $('#tabProd .spinner').addClass('hide');
                
                }
            });
        }
    });

    $('#altrelated').appear();
    var loadedaltrelated = false;
    $('#altrelated').on('appear', function(e){
        e.stopPropagation();
        if(!loadedaltrelated){
            $('.loadingPagear').removeClass('hide');
            loadedaltrelated = true;
            $.ajax({
                url: '/productmvc/GetAltRelProductsAsync',
                type: 'POST',
                data: { 'productID': prodID},
                success: function (data) {
                    
                    $('#altrelated').append(data);
                    prodScrollerJS.InitAltRelatedItemsScroller();
                    $('#altrelated .spinner').addClass('hide');       
                },
                error: function(){
                	$('#altrelated').off();
                	$('#altrelated').html('');  
                }
            });
        }
    });

if($('#altitemslist').length){
    $('#altitemslist').appear();
    var loadedaltitems = false;
    $('#altitemslist').on('appear', function(e){
        e.stopPropagation();
        if(!loadedaltitems){
            $('.loadingPagear').removeClass('hide');
            loadedaltitems = true;
            $.ajax({
                url: '/productmvc/GetAltItemsAsync',
                type: 'POST',
                data: { 'productID': prodID},
                success: function (data) {
                    
                    $('#altitemslist').append(data);
                    
                    prodScrollerJS.InitAltItemsScroller();
                    $('#altitemslist .spinner').addClass('hide');
                    FixIE11SVG();
                }
            });
        }
    });  
}
   
//load minirating in
$.ajax({
    url: '/productmvc/minirating',
    type: 'POST',
    data: { 'catalias': $('#CatalogAlias').val()},
    success: function (data) {
        
        $('#ratingSpot').append(data);
        
        if(isMobile){
        
    		$("#ratingSpot").removeClass("Rating")
    					    .addClass("marginLeft15");
		$("#minirating  .ratingStarBase  svg")
			.attr("height", "15px")
			.attr("width", "15px");
		$("#minirating  .starBackground").css("width", "80px");
		$("#minirating  .starForeground").css("width", "76px");
		$("#gotoreviews").addClass("padding5");

	}
	
	$("#miniReviewLink").on("click", function(e){
		//if (e.type =='keypress' && !(e.which == 13)) { return;}
		
		if($('a.anchor[name="reviews"]').length){
			return;	
		}
		
		e.preventDefault();
		ScrollToElement('#detailTabs');
			
	});
	
       $('#minirating').on('mouseenter focus', function(){
        $('#ministars').fadeIn('fast');
       })
       .on('mouseleave', function(){
           $('#ministars').fadeOut('fast');
       });
       FixIE11SVG();
    }
});
if($('.jslider-pointer').length){
	$('.jslider-pointer').on("keydown", function(e){
	        
	    if(e.keyCode == 37){//left
	        DecreaseGlideValue();
	    }else if(e.keyCode == 39){//right
	        IncreaseGlideValue();
	    }
	});
}

 $('.prodCopyTabs').each(function () {
    $('#' + this.id).on("click  keydown",function (e) {
        if (e.type =='keydown' && !(e.keyCode == 13)) { return;}
        $('.prodCopyTabs')
        	.removeClass('bkgdBlue textWhite')
        	.addClass('bkgdMdGray');
    		$('.prodCopyTabs').attr({
                'aria-selected': 'false'

    		}); 
        $('#' + this.id).removeClass('bkgdMdGray').addClass('bkgdBlue textWhite');
        $('#' + this.id).attr({
                'aria-selected': 'true'
        });
        $('.pcTab').addClass('hide').hide();
        $('.pcTab').attr('aria-hidden', 'true');
        $('.pcTab').attr('aria-expanded', 'false');
        $('#' + this.id + 'Tab').removeClass('hide').show();
        $('#' + this.id + 'Tab').attr('aria-hidden', 'false');
        $('#' + this.id + 'Tab').attr('aria-expanded', 'true');
        $('.prodTabArrow').removeClass('rotate180').addClass('rotate90');
        $('#' + this.id + 'Arrow').removeClass('rotate90').addClass('rotate180');
    });
});

//prop65 stuff
if($('#prop65dialog').length){
	var prop65Dialog = dialog4i();
	prop65Dialog.init(document.getElementById('prop65dialog'), document.getElementsByClassName('prop65'), document.getElementById('btnProp65OK'));
	$('.prop65').on('click', function(e){
	    //if (e.type =='keypress' && !(e.which == 13)) { return;}
        e.preventDefault();

        //load html in via ajax
        $.ajax({
	        url: '/product/prop65',
	        type: 'post',
	        data: { 'ProductID': prodID},
	        success: function (result) {
	            $('#prop65content').html(result);
	            $('.loadingModal').hide();
	        },
	        error: function (result){
	            $('#prop65content').html("There was an issue loading the warnings, please refresh the page and try again.");
	            $('.loadingModal').hide();
	        }
	    });
	
	});
}
//end prop65 stuff

});//end js file, anything added after this will have a global scope....